/* eslint-disable complexity */
/* eslint-disable max-params */
/**
 * @author sunzhiguang
 * @date 2020/7/2
 */
import {
  AI_CHAT_PREDICT,
  AI_FILE_SUMMARY_TYPES,
  AI_IMAGE_INTENT_TYPES,
  ChatMessage,
  ChatMessageType,
  ClientType,
  Employee,
  EmployeeAttribute,
  Group,
  GroupApprovalRule,
  GroupAttribute,
  GroupKind,
  GroupRoster,
  IAIMessageBody,
  IMessageDetectItem,
  MessageEmitCategory,
  MessageRespType,
  MessageStatus,
  NoticeMessageRespType,
  Session,
  SessionType,
  UID
} from "@/types/chat";
import { lookup } from "mime-types";
import { getFileUrl, shortFileName, stringEncode, userEscapeString } from "@/utils/chat/index";
import {
  convertUidToString,
  generateMessageId,
  isGroupAIMerge as sdkIsGroupAIMerge,
  isGroupCleanMessage,
  parseUidFromSingleSessionId
} from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { MessageSendType, SessionSettingsType } from "@/types/chat/enum";
import sysMsgConfig from "@/components/chat/config";
import i18n from "@/i18n";
import get from "lodash/get";
import lodashGroupBy from "lodash/groupBy";

import config, { ChatConfig } from "@/config/config";
import { convertStringToEmoji, convertStringToNoticeEmoji } from "@/components/chat/utils/ddemoji";
import pick from "lodash/pick";
import { UserCardData } from "@/types/UserCard";
import { mattchEmoji } from "@/components/chat/message/Input/Emoji";
import attempt from "lodash/attempt";
import isError from "lodash/isError";
import { combGroupSetField } from "@/components/chat/message/Item/common";
import {
  EmojiMessageContentItem,
  MessageExtAction,
  ChatMessageExtType,
  GroupNoticeMessageContentItem,
  QuickReplyMessageContentItem,
  ReplyEmojiMessageContentItem
} from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/Type";
import QuickEmojiMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/QuickEmoji";
import ReplyEmojiMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/ReplyEmoji";
import GroupNoticeExtMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/GroupNotice";
import { FocusSDK, isBjme } from "@/utils";
import { User } from "@/types/supervise";
import { urlReg, urlPatt } from "@/utils/chat/joyspace-file";
import CHAT_NOTICE, { OTHER_EXCLUDE_TABS_PIN } from "@/contant/chat";
import { checkJoyspaceUrl, legalJoyspaceUrlReg } from "@/components/Joyspace/util";
import { getPageStatus, shareJoyspaceFiles } from "@/components/Joyspace/api/page";
import { PageType, PermissionEnum } from "@/components/Joyspace/const";
import JoyspaceFileMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/message/JoyspaceFile";
import TextMessageBody, { QuickReplyStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Text";
import { joyspacePermissionType } from "@/components/Joyspace/config/permissions.config";
import { changeGovUrl } from "@/utils/tools";
import { reduceData } from "@jd/jdee.im.sdk/lib/es/utils/reduceSender";

import { VoiceMessageMap } from "@/types/chat/State";
import { addXclient } from "@/utils/addToken";
import Bus from "@/utils/bus";
import ImService from "@/server/ImService";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { cloneDeep, findLast, flatMapDeep, omit, uniqWith } from "lodash";
import { duccConfigI18 } from "@/utils/i18n";
import { getTitleByCardConvertLink, sendChatMessageBatch, voiceToText } from "@/api/chat";
import { getUserAlias } from "./group";
import { message as toast } from "antd";
import { getAIChatWinSessionId, isCustomAppSession } from "./session";
import QuickReplyMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/QuickReply";
import { openJoyspacePreview } from "@/components/Joyspace/util";
import { getWpsPreviewCode } from "@/api/llm";

export const QUICK_REPLY_TIP_KEY = "QUICK_REPLY_TIP_KEY";
export const AICHAT_MSG_TIP_KEY = "AICHAT_MSG_TIP_KEY";

export const AI_CHAT_PREDICT_TYPE = [
  "FILE_SUMMARY",
  "CREATE_MEETING",
  "CREATE_SCHEDULE",
  "AGENT_CONTACT",
  "INTENT"
];

export const SUPPORT_AI_DETECT_MSG_TYPE = [
  ChatMessageType.TEXT,
  ChatMessageType.FILE,
  ChatMessageType.EGOV_FILE,
  ChatMessageType.JOYSPACEFILE
];

import DeeplinkEvent, { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import { buildPagePathKey } from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import { unknown } from "@/assets/images/joyspace";

// 获取意图识别角色 SENDER/RECEIVER
export const getMessageDetectRole = (props: { message: any; currentEmployee: Employee }) => {
  const { message, currentEmployee } = props;
  const { sender } = message;
  const mine = convertEmployeeToString(sender) === convertEmployeeToString(currentEmployee);
  return mine ? "SENDER" : "RECEIVER";
};

export const praseMessageFileData = async (msg: any) => {
  const realUrl = msg.url || msg.webUrl;
  const url = await addXclient(getFileUrl(realUrl));
  return {
    fileType: `${msg.pageType || 2}`,
    filename: msg.name || msg.fileName,
    fileKey: msg.fileId,
    fileUrl: url
  };
};

// 意图类别
export const buildMessageDetect = (msgs: any[], session: Session) => {
  const res: any[] = [];
  msgs.forEach((item: any) => {
    const msg = {
      ...item,
      ...item.body
    };
    if (SUPPORT_AI_DETECT_MSG_TYPE.includes(msg.type)) {
      const i: any = {
        ...pick(msg, ["sender", "from", "mid", "to"]),
        ...pick(session, ["sessionId", "gid", "sessionType"]),
        msgUUID: msg.id,
        sessionGroup: 1,
        text: msg.content || ""
      };
      if (
        [ChatMessageType.FILE, ChatMessageType.JOYSPACEFILE, ChatMessageType.EGOV_FILE].includes(
          msg.type
        )
      ) {
        i.file = {
          fileType: `${msg.pageType || 2}`,
          filename: msg.name || msg.fileName,
          fileKey: msg.fileId,
          fileTag: msg.fileTag || 0
        };
      }
      res.push(i);
    }
  });
  return {
    ...res[0],
    role: "SENDER"
  };
};

// 处理消息AI感知数据
export const mapMessageDetectRes = (msgDetec: IMessageDetectItem, rawMsgs: any) => {
  let newMsg = { ...rawMsgs, ...rawMsgs.body };
  if (rawMsgs.id === msgDetec.msgId) {
    newMsg = {
      ...newMsg,
      intentData: {
        ...msgDetec
      }
    };
  }
  return newMsg;
};

export const buildTemplate2Data = ({
  message,
  nativeId,
  items
}: {
  message: any;
  nativeId: string;
  items: any;
}) => {
  return {
    ...message,
    type: ChatMessageType.TEMPLATE2,
    template: {
      nativeId
    },
    data: [items]
  };
};

export const buildAIChatMessageComm = async ({
  sessionId,
  currentEmployee,
  message,
  predictType,
  prompt = ""
}: {
  sessionId: string;
  currentEmployee: Employee;
  message: IAIMessageBody;
  predictType: AI_CHAT_PREDICT;
  prompt?: string;
}): Promise<any> => {
  let content = "";
  if (message.type === ChatMessageType.TEXT) {
    content = message.content;
  } else if (AI_FILE_SUMMARY_TYPES.includes(predictType)) {
    content = message.name || message.fileName || message.content || "";
  } else if (AI_IMAGE_INTENT_TYPES.includes(predictType)) {
    content = message.content;
  }
  let question = content;
  const tipRich = i18n.t("chat:quill-old-version-tip");
  question = removeFirstOccurrence(question, tipRich);
  if (prompt) {
    question = prompt.replace(/\$\{text\}/, question);
  }
  let messageBody: any = {
    type: message?.type || ChatMessageType.TEXT,
    content: question,
    question,
    predictType,
    isMyself: true,
    msgSendTime: message.timestamp || new Date().getTime()
  };
  if ([...AI_FILE_SUMMARY_TYPES].includes(predictType)) {
    // 文件摘要
    if (message.files) {
      messageBody.files = [];
      for (let i = 0; i < message.files?.length; i++) {
        const input = message.files[i];
        const file = await praseMessageFileData(input);
        messageBody.files.push(file);
      }
    } else {
      const file = await praseMessageFileData(message);
      messageBody.files = [file];
    }

    // template2
    messageBody = buildTemplate2Data({
      message: messageBody,
      nativeId: "share_file_link",
      items: {
        files: messageBody.files
      }
    });
  } else if ([...AI_IMAGE_INTENT_TYPES].includes(predictType)) {
    // 文件摘要
    if (message.files) {
      messageBody.files = [];
      for (let i = 0; i < message.files?.length; i++) {
        const input = message.files[i];
        const file = await praseMessageFileData({
          ...input,
          type: 0
        });
        messageBody.files.push(file);
      }
    } else {
      const file = await praseMessageFileData(message);
      messageBody.files = [file];
    }

    // template2
    messageBody = buildTemplate2Data({
      message: messageBody,
      nativeId: "share_images_card",
      items: {
        files: messageBody.files
      }
    });
  } else if (predictType === AI_CHAT_PREDICT.WORK_SUMMARY) {
    // 文件摘要
    if (message.files) {
      messageBody.files = [];
      for (let i = 0; i < message.files?.length; i++) {
        const input = message.files[i];
        const file = await praseMessageFileData(input);
        messageBody.files.push(file);
      }
    } else {
      const file = await praseMessageFileData(message);
      messageBody.files = [file];
    }

    // template2
    messageBody = buildTemplate2Data({
      message: messageBody,
      nativeId: "share_file_link",
      items: {
        files: messageBody.files
      }
    });
  } else if (predictType === AI_CHAT_PREDICT.MESSAGE_SUMMARY) {
    // 消息摘要
    messageBody.messages = [...(message.fixMessages || [])];
  }
  const msg: Partial<ChatMessage> = initCommChatMessageInfo({
    sessionId,
    currentEmployee,
    message: messageBody as any
  });
  return msg;
};

/**
 * 发送数据到智能助理
 * {
  currentEmployee // 当前用户
  message // 数据
  predictType // 意图类型
  prompt // 提示语
 }
 */
export const sendIntentMessageToAI = async ({
  currentEmployee,
  message,
  predictType,
  prompt
}: {
  currentEmployee: Employee;
  message: IAIMessageBody;
  predictType: AI_CHAT_PREDICT;
  prompt?: string;
}) => {
  // 打开窗口
  const sid = await getAIChatWinSessionId();
  FocusSDK.launchAIChatSession(
    `aiRobot:dd.notice:focus.bot:${convertEmployeeToString(currentEmployee)}:chat`,
    () => {},
    true
  );
  const msg = await buildAIChatMessageComm({
    sessionId: sid,
    currentEmployee,
    message,
    predictType,
    prompt
  });
  FocusSDK.sendMainMessage("aichat.chatEvent", { sessionId: sid, data: msg, agentType: "chat" });
};

export const createJoySpaceLink = (data: any, joyspaceHost: string) => {
  let content;
  if (data.pageType === PageType.Form) {
    // 低代码
    content = data.link;
    return content;
  }
  const path = buildPagePathKey(data.pageType).subPath;
  const link = `${joyspaceHost}/${path}/${data.id}`;
  return `${link}`;
};

export const initCommChatMessageInfo = ({
  sessionId,
  currentEmployee,
  message,
  task
}: {
  sessionId: string;
  currentEmployee: Employee;
  message: Partial<ChatMessage>;
  task?: any;
}): Partial<ChatMessage> => {
  const timestamp = new Date().getTime();
  const id = generateMessageId();
  let _currentEmployee = currentEmployee;
  if (!currentEmployee?.userId) {
    _currentEmployee = getCurrentUserFromLocal() as Employee;
  }
  return {
    category: MessageEmitCategory.CHAT_MESSAGE,
    sessionId,
    taskId: task?.id,
    task,
    mid: 0,
    beforeMid: 0,
    sender: _currentEmployee,
    ...message,
    timestamp,
    id,
    status: MessageStatus.INIT // 需要发送的消息内容需初始化状态为INIT
  };
};

export const initChatMessageInfo = ({
  selectedSession,
  currentEmployee,
  message,
  task
}: {
  selectedSession: Session;
  currentEmployee: Employee;
  message: Partial<ChatMessage>;
  task?: any;
}): Partial<ChatMessage> => {
  const timestamp = new Date().getTime();
  const id = generateMessageId();
  let _currentEmployee = currentEmployee;
  if (!currentEmployee?.userId) {
    _currentEmployee = getCurrentUserFromLocal() as Employee;
  }
  return {
    category: MessageEmitCategory.CHAT_MESSAGE,
    sessionId: selectedSession.sessionId,
    taskId: task?.id,
    task,
    mid: 0,
    beforeMid: 0,
    sender: _currentEmployee,
    timestamp,
    id,
    status: MessageStatus.INIT, // 需要发送的消息内容需初始化状态为INIT
    ...message
  };
};

export function buildGroupNoticeMessageBody({
  content,
  currentEmployee,
  data
}: {
  content: string;
  currentEmployee: Employee;
  data: any;
}): any {
  const timestamp = new Date().getTime();
  const messageBody: any = {
    type: ChatMessageType.GROUPNOTICE,
    content: content,
    sender: currentEmployee,
    category: MessageEmitCategory.CHAT_MESSAGE,
    timestamp,
    ...data
  };
  return messageBody;
}

export function buildsolitaireMessage({
  content,
  currentEmployee,
  data
}: {
  content: string;
  currentEmployee: Employee;
  data: any;
}): any {
  const timestamp = new Date().getTime();
  const messageBody: any = {
    type: ChatMessageType.SOLITAIRE,
    content: content,
    sender: reduceData(currentEmployee),
    category: MessageEmitCategory.CHAT_MESSAGE,
    timestamp,
    ...data
  };
  return messageBody;
}

/**
 * 快速回复消息
 */
export function buildQuickReplyMessageBody({
  session,
  mid,
  msgContentItem,
  quick_reply_status = undefined,
  action = undefined
}: {
  session: Partial<Session>;
  mid: number;
  msgContentItem?: QuickReplyMessageContentItem;
  quick_reply_status?: QuickReplyStatus;
  action?: MessageExtAction;
}): Partial<QuickReplyMessageBody> {
  const data: Partial<QuickReplyMessageBody> = {
    msgType: ChatMessageExtType.QUICK_REPLY,
    mid: mid,
    sessionGroup: 1,
    sessionId: session.sessionId,
    sessionType: session.sessionType
  };
  if (msgContentItem) {
    data.msgContent = [msgContentItem];
  }
  if (quick_reply_status !== undefined) {
    data.quick_reply_status = quick_reply_status;
  }
  if (action !== undefined) {
    data.action = action;
  }
  return data;
}

export async function openQuickReplyManual(options: any) {
  return new Promise((resolve) => {
    const { message, selectedSession, status } = options;
    const msg = buildQuickReplyMessageBody({
      mid: message.mid,
      session: selectedSession,
      quick_reply_status: status
    });
    if (msg) {
      ImService.getInstance()
        ?.sendChatMessageExt(selectedSession.sessionId, msg)
        .finally(() => {
          toast.success({
            key: QUICK_REPLY_TIP_KEY,
            content: status === QuickReplyStatus.OPEN ? "成功发起回复" : "已关闭回复"
          });
          resolve(true);
        });
    } else {
      resolve(false);
    }
  });
}

// 发送消息
export async function handleSendTextMessage(message: any) {
  return new Promise((resolve) => {
    // 删除不需要的属性
    const messageId = message.id;
    const sessionId = message.sessionId;
    const messageBody = omit(cloneDeep(message), [
      "status",
      "taskId",
      "task",
      "mid",
      "beforeMid",
      "sessionId",
      "groupId",
      "status",
      "statusType",
      "_id",
      "_rev",
      "belong",
      "datetime",
      "mid",
      "localSendTimestamp",
      "readNum",
      "readUids",
      "plusList"
    ]) as any;
    const imService = ImService.getInstance();
    let { url, webUrl } = messageBody;
    if (url) {
      messageBody.url = changeGovUrl(messageBody.url);
    }
    if (webUrl) {
      messageBody.webUrl = changeGovUrl(messageBody.webUrl);
      messageBody.content = changeGovUrl(messageBody.content);
    }
    imService
      .sendChatMessage(sessionId, messageId, messageBody)
      .then((result) => {
        if (result?.mid && result.id === messageId) {
          resolve({
            sessionId: messageBody.sessionId,
            result: result
          });
        } else {
          result.statusType = MessageStatus.FAILED;
          result.status = MessageStatus.FAILED;
          resolve({
            sessionId: messageBody.sessionId,
            result: result
          });
        }
      })
      .catch(() => {
        resolve({
          sessionId: messageBody.sessionId,
          result: messageBody
        });
      });
  });
}

/**
 * 构建 文本消息体
 * @param content
 * @param atUsers
 * @param replyMessage
 */
export function buildTextMessageBody(
  content: string,
  atUsers: UID[],
  replyMessage?: ChatMessage,
  messageTypeOption?: HttpCardLinkTypeOption,
  displayContent?: ContentItem[],
  quillJson?: any,
  quillImage?: any,
  style?: any,
  to?: any
): Partial<TextMessageBody> {
  const isPlainText = displayContent
    ? displayContent.every((item) => item.type === MessageCardType.Text)
    : true;
  if (to?.clientType) {
    to.clientType = to.clientType.toLowerCase();
    if (to.clientType === "windows") {
      to.clientType = ClientType.PC;
    }
  }
  const messageBody: any = {
    type: ChatMessageType.TEXT,
    content: changeGovUrl(content),
    atUsers: atUsers,
    style: style,
    to: to,
    ...messageTypeOption,
    displayContent: isPlainText ? undefined : displayContent,
    quillJson: quillJson,
    quillImage: quillImage
  };
  if (replyMessage?.mid) {
    const replayMid = Math.floor(replyMessage?.mid || 0);
    const rootId = Math.floor(replyMessage.reply?.root || 0);
    const sender = replyMessage.sender as Employee;
    const root = rootId || replayMid;
    Object.assign(messageBody, {
      reply: {
        mid: replayMid,
        root: root,
        uid: { ...employeeToUid(sender), nickName: sender?.name || sender?.nickName }
      }
    });
  }
  if (
    (displayContent?.length === 1 &&
      (displayContent[0].type === MessageCardType.ShortLink ||
        displayContent[0].type === MessageCardType.HttpTopic)) ||
    !isQuillMsg(messageBody?.quillJson)
  ) {
    delete messageBody.quillJson;
  }
  return messageBody;
}

// 处理atContent、displayContent内容，方便处理@人员信息后面显示组昵称
export function handleExpandContent(messageBody: any, session: Session) {
  const { content, atUsers, displayContent } = messageBody;
  const arr = displayContent
    ? [{ content, type: MessageCardType.Text }, ...displayContent]
    : [{ content, type: MessageCardType.Text }];
  const tempArr = arr.map((item: ContentItem) => {
    if (item.type === MessageCardType.Text) {
      let atContent = item.content;
      if (atUsers && atUsers?.length > 0) {
        let tempIndex = 0;
        let temp = [];
        for (const u of atUsers) {
          let mentionItem = u;
          if (typeof u === "string") {
            mentionItem = JSON.parse(u);
          }
          const alias = mentionItem.alias ? `（${mentionItem.alias}）` : "";
          const atStr = `@${mentionItem.nickname}`;
          tempIndex = atContent.indexOf(atStr);
          if (tempIndex > 0) {
            temp.push(atContent.substring(0, tempIndex));
          }
          if (tempIndex === -1) {
            continue;
          }
          temp.push(`@${mentionItem.nickname}${alias}`);
          atContent = atContent.substr(tempIndex + atStr.length);
        }
        atContent = temp.join("") + atContent;
      }
      return {
        ...item,
        atContent
      };
    }
    return item;
  });

  return {
    ...messageBody,
    atContent: tempArr[0].atContent,
    displayContent: tempArr.length > 1 ? tempArr.slice(1) : undefined
  };
}

// 处理接口返回值
export function handleJoyspaceLinkPermission(page: any, permissionType: any) {
  let currentPermission = joyspacePermissionType.ReadNothing;
  let permission = -1;
  if (!page) {
    return {
      currentPermission,
      permission
    };
  }
  let permissions = page.permissions;
  if (permissions?.includes(PermissionEnum.PAGE_EDIT)) {
    permission = 1;
  } else if (page.permissions) {
    permission = 2;
  }
  if (permissions) {
    currentPermission = permissionType ? permissionType : 2;
  }
  return {
    // @ts-ignore
    currentPermission,
    permission
  };
}

/**
 * 构建 joyspace 链接识别成卡片的消息体
 * @param content
 * @param atUsers
 * @param url
 * @param replyMessage
 */
// eslint-disable-next-line max-params
/**
 * 场景一: 点击+号，选择云文档发送
 * 场景二: input输入，发送消息
 */
export function buildJoyspaceLinkMessageBody(
  content: string,
  messageTypeOption: JouspaceLinkTypeOption,
  atUsers: UID[],
  selectedSession: Session,
  replyMessage?: ChatMessage,
  permissionType?: joyspacePermissionType
): Promise<Partial<JoyspaceFileMessageBody | any>> {
  return new Promise((resolve) => {
    const messageBody = buildTextMessageBody(content, atUsers, replyMessage);
    let { webUrl, fileId } = messageTypeOption;
    webUrl = changeGovUrl(webUrl);
    const info = selectedSession.info;
    // console.log(permissionType, 'permissionTypepermissionType');
    shareJoyspaceFiles({
      page_ids: [fileId],
      to_eepaas_users: !selectedSession.isGroup
        ? [
            {
              teamId: (info as EmployeeAttribute).teamId,
              userId: (info as EmployeeAttribute).userId,
              permission_type: permissionType || 2
            }
          ]
        : [],
      to_groups: selectedSession.isGroup
        ? [{ gid: (info as GroupAttribute).gid, permission_type: permissionType || 2 }]
        : []
    })
      .then((res) => {
        const resObj = res[fileId] || {};
        const fileName = resObj.page.title;
        const pageType = resObj.page.page_type || messageTypeOption.pageType;
        // @ts-ignore
        resolve({
          ...messageBody,
          type: ChatMessageType.JOYSPACEFILE,
          fileName,
          fileId,
          webUrl,
          iconUrl: resObj.page.icon_url || "",
          // @ts-ignore
          pageType,
          ...handleJoyspaceLinkPermission(resObj.page, permissionType)
        });
      })
      .catch((err) => {
        // console.log(err, 'errerrerr');
        resolve({
          ...messageBody,
          type: ChatMessageType.JOYSPACEFILE,
          webUrl,
          fileId,
          iconUrl: "",
          // @ts-ignore
          currentPermission: -1,
          permission: -1,
          pageType: messageTypeOption.pageType || 1
        });
      });
  });
}

export function buildMeetingPermission(options: any) {
  const messageBody: any = {
    type: ChatMessageType.PERMISSION_CHANGE,
    ...options
  };
  return messageBody;
}

/**
 * 构建 图片消息体
 * @param url
 * @param size
 * @param width
 * @param height
 */
// eslint-disable-next-line max-params
export function buildImageMessageBody(
  url: string,
  size: number,
  width: number,
  height: number,
  isOriginal?: boolean
): Partial<ChatMessage> {
  return {
    url: url,
    size: size,
    width: width,
    height: height,
    type: ChatMessageType.IMAGE,
    isOriginal
  };
}

/**
 * 构建 文件消息体
 * @param url
 * @param name
 * @param size
 * @param fileType
 * @param localPath
 */
// eslint-disable-next-line max-params
export function buildFileMessageBody(
  url: string,
  name: string,
  size: number,
  fileType: string,
  localPath?: string,
  isEgovFile?: boolean,
  fileTag = 0
): Partial<ChatMessage> {
  return {
    type: (isEgovFile ? ChatMessageType.EGOV_FILE : ChatMessageType.FILE) as any,
    url: url,
    name: name,
    size: size,
    fileType: fileType.length > 0 ? fileType : lookup(name) || "",
    upLocalPath: localPath || "111",
    fileTag
  };
}

export function buildTemplate2MessageBody({ nativeId, data, currentEmployee, id }: any) {
  return {
    type: ChatMessageType.TEMPLATE2,
    template: {
      nativeId: nativeId
    },
    // code: 0,
    data: data,
    // mid: 0,
    // beforeMid: 0,
    sender: currentEmployee,
    timestamp: Date.now(),
    id: id
  };
}

// 判断是否是三方应用发过来的消息卡片
export function isTemp2CommonCardMsg(message: any) {
  if (message.type === ChatMessageType.TEMPLATE2) {
    if (message?.template?.nativeId === "common_card") {
      return true;
    }
  }
  return false;
}

/**
 * 构建批量发消息参数、支持消息卡片组件
 * @param cardInfo 三方应用传过来的数据
 * @param toUidList 单聊接受列表
 * @param gidList 群组接受列表
 */
export async function buildTemplate2MessageBodyBatch({
  cardInfo,
  toUidList,
  gidList
}: any): Promise<any> {
  const template2Body = {
    type: ChatMessageType.TEMPLATE2,
    template: {
      nativeId: "common_card"
    },
    data: [{ common_card: cardInfo }]
  };
  const message = {
    body: template2Body,
    type: "chat_message",
    timestamp: Date.now(),
    lang: "zh_CN",
    aid: "",
    ver: "4.3"
  };
  const authInfo = FocusSDK.authInfo;
  const from = {
    app:
      authInfo?.ddAppId ||
      (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
      process.env.REACT_APP_DD_APPID ||
      "gwork",
    pin: authInfo?.userId || "",
    teamId: authInfo?.teamUserInfo.teamId || "",
    clientType: (window as any).user.clientType || ClientType.PC
  };
  if (!(cardInfo.applicationName && cardInfo.applicationKey && cardInfo.title)) {
    toast.warn("参数不合法");
    return;
  }
  const result = await sendChatMessageBatch({ message, from, toUidList, gidList });
  return result;
}

export function buildJoySpaceDocShareBody(data: any): Partial<ChatMessage> {
  let type = "document";
  switch (data.pageType) {
    case 1:
      type = "document";
      break;
    case 2:
      type = "week_report";
      break;
    case 4:
      type = "table";
      break;
    case 6:
      type = "file";
      break;
    default:
      break;
  }
  const sharelink: any = {
    ext: `{"type":"${type}"}`,
    icon: data.icon,
    // source: '云空间',
    source: isBjme() ? "云文件" : duccConfigI18.joyspace,
    // category: 'jd_doc',
    title: data.title,
    content: data.content,
    url: data.url,
    type: data.type,
    pageType: data.pageType
  };

  if (type === "file") delete sharelink.category;
  return {
    type: ChatMessageType.TEMPLATE2,
    template: {
      nativeId: "share_link"
    },
    code: 0,
    data: [
      {
        sharelink: sharelink,
        type: 0
      }
    ]
  };
}

/**
 * 构建 文本消息体
 */
// action: "add"
// deviceCode: "71eac0a4-e7b7-4c2c-9799-f6fc6773c8c4"
// mid: 223067597
// msgContent: [{…}]
// msgType: "plusOne"
// sender: {app: "me", clientType: "ios", pin: "X1AaVWkcGRMdVVvoB0mGN", nickName: "侯庆祥", teamId: "mS2CKU8HN3UFxdliJ1AxR"}
// sessionGroup: 2
// sessionId: "1080002362"
// sessionType: 2
export function buildQuickEmojiMessageBody({
  msgType,
  session,
  mid,
  action,
  msgContentItem
}: {
  msgType: ChatMessageExtType.PIUS_ONE;
  session: Partial<Session>;
  mid: number;
  action: MessageExtAction;
  msgContentItem: EmojiMessageContentItem;
}): Partial<QuickEmojiMessageBody> {
  return {
    msgType: ChatMessageExtType.PIUS_ONE,
    action,
    mid: mid,
    msgContent: [msgContentItem],
    sessionGroup: 1,
    sessionId: session.sessionId,
    sessionType: session.sessionType
  };
}

/**
 * 构建 组通知回复
 */
export function buildGroupMessageBody({
  msgType,
  session,
  mid,
  msgContentItem
}: {
  msgType: ChatMessageExtType.GROUP_NOTICE;
  session: Partial<Session>;
  mid: number;
  msgContentItem: GroupNoticeMessageContentItem;
}): Partial<GroupNoticeExtMessageBody> {
  return {
    msgType,
    mid: mid,
    msgContent: [msgContentItem],
    sessionGroup: 1,
    sessionId: session.sessionId,
    sessionType: session.sessionType
  };
}

/**
 * 构建快捷回复常用语
 * @returns
 */
export function buildReplyEmojiMessageBody({
  session,
  mid,
  msgContentItem,
  action = undefined
}: {
  session: Partial<Session>;
  mid: number;
  msgContentItem?: ReplyEmojiMessageContentItem;
  action?: MessageExtAction;
}): Partial<ReplyEmojiMessageBody> {
  const data: Partial<ReplyEmojiMessageBody> = {
    msgType: ChatMessageExtType.QUICK_REPLY_EMOJI,
    mid: mid,
    sessionGroup: 1,
    sessionId: session.sessionId,
    sessionType: session.sessionType
  };
  if (msgContentItem) {
    data.emojiContent = [msgContentItem];
  }
  if (action !== undefined) {
    data.action = action;
  }
  return data;
}

/**
 * 发送常用语
 * @param options
 * @returns
 */
export function sendReplyEmojiMessage(options: any) {
  return new Promise((resolve) => {
    const { message, session, msgContentItem, action } = options;
    const msg = buildReplyEmojiMessageBody({
      mid: message.mid,
      session,
      msgContentItem,
      action
    });
    if (msg) {
      ImService.getInstance()
        ?.sendChatMessageExt(session.sessionId, msg)
        .finally(() => {
          resolve(true);
        });
    } else {
      resolve(false);
    }
  });
}

export function getQuickItem(quickReplys: any[], str: string) {
  return quickReplys?.find((i) => i?.detail === str);
}

/**
 * 判断AI助手卡片通知是否展示老样式
 * @param message
 * @returns boolean
 */
export function isShowOldNoticeCard(message: any) {
  const isOldStyle = !message.extend?.messageFormatVer || message.extend?.messageFormatVer === "v1";
  return isOldStyle;
}

/**
 * 判断AI助手卡片通知是否有老样式转为新样式（前提是调取的老接口）
 * @param message
 * @returns boolean
 */
export function isShowFakeNoticeCard(message: any) {
  const isFakeStyle = isShowOldNoticeCard(message) && message.extend?.adapteNewStyle === "true";
  return isFakeStyle;
}

/**
 * 获取joyspace的链接，有且只有一个链接且是joyspace链接时才返回
 * @param text
 * @returns
 */
export function getJoyspaceUrl(text: string): string {
  let joyspaceCount = 0;
  let url = "";
  const matchUrls = text.match(urlReg) || [];
  matchUrls.forEach((item) => {
    if (legalJoyspaceUrlReg.test(item)) {
      url = item;
      joyspaceCount++;
    }
  });
  if (joyspaceCount === 1) return url;
  return "";
}

/**
 * 判断是否是joyspace_link 类型
 * @param text
 * @returns
 */
export function checkJoyspaceLink(url: string): any {
  // const joyspaceUrl = getJoyspaceUrl(url);
  const joyspaceUrl = legalJoyspaceUrlReg.test(url) ? url : " ";
  if (joyspaceUrl) {
    const result = checkJoyspaceUrl(joyspaceUrl);
    return result;
  }
  return {
    is: false,
    url: ""
  };
}

export enum MessageCardType {
  Text = "Text", // 纯文本
  Card = "Card", // 卡片格式  无此格式
  JoyspaceTopic = "JoyspaceTopic", // joyspace链接请求服务端返回了标题
  HttpTopic = "HttpTopic", // http链接请求服务端返回了标题 暂时没有这个类型，涉及不到请求服务器
  ShortLink = "ShortLink", // 短链（包含http链接、安装包链接、joyspace请求服务端错误返回的原链接等等）
  Image = "Image", // 图片 （富文本消息包含图片
  List = "list", // （富文本里的有序列表无序列表
  UserLink = "UserLink" // 人员高亮气泡
}
export interface ContentItem {
  content: string; // 标题或内容
  atContent?: string;
  url?: string;
  egovWebUrl?: string;
  type: MessageCardType;
  startIndex?: number; // 如果是一个链接的话，这个stratIndex应该没有用 没有一个链接的情况，因为手动选择复制的结果全部是文本，可能这个字段没有用了。
  ext?: string; // json字符串
}

/**
 * 创建链接消息体
 * @param body
 * @returns
 */
export function buildUrlMessageBody(body: ContentItem): ContentItem {
  return {
    content: body.content,
    url: body.url,
    egovWebUrl: body.egovWebUrl,
    type: body.type,
    startIndex: body.startIndex,
    ext: body.ext
  };
}

/**
 * 字符串根据url正则转换成数组
 * @param content 将要被转换成数组的字符串
 */
export function convertContentToArray(content: any, data = {}) {
  const regexp = new RegExp(urlPatt);
  if (!content) {
    return [];
  }
  const matches = content.matchAll(regexp);
  const subIndexArr: any[] = [];
  const result: ContentItem[] = [];
  for (const match of matches) {
    const sIndex = match.index;
    let input = match[0];
    let endChar = match[0].substr(-1);
    // console.log('input', input, 'endChar', endChar);
    if (!/[A-Za-z0-9+&#\/%=~_|]/.test(endChar)) {
      // console.log(222);
      input = match[0].substring(0, match[0].length - 1);
      endChar = input.substr(-1);
    }
    // console.log(input);
    subIndexArr.push({ sIndex, eIndex: sIndex + input.length });
  }
  if (!subIndexArr.length) {
    result.push({
      content,
      url: undefined,
      type: MessageCardType.Text,
      startIndex: 0,
      ext: undefined
    });
  } else {
    // console.log('subIndexArr', subIndexArr);
    const con = content as string;
    subIndexArr.forEach((item, idx) => {
      if (idx === 0) {
        const contentReal = con.substring(item.sIndex, item.eIndex);
        const isOnlyHttp =
          contentReal.includes("3.cn") ||
          contentReal.includes("joyspace") ||
          contentReal === content;
        result.push(
          buildUrlMessageBody({
            // content: isOnlyHttp ? contentReal : (data as any)?.fileName || contentReal,
            content: (data as any)?.fileName || contentReal,
            url: contentReal,
            // type: isOnlyHttp ? MessageCardType.ShortLink : MessageCardType.HttpTopic,
            type:
              subIndexArr.length > 1 || !(data as any)?.fileName
                ? MessageCardType.ShortLink
                : MessageCardType.HttpTopic,
            startIndex: item.sIndex,
            egovWebUrl: (data as any)?.egovWebUrl,
            ext: undefined
          })
        );
        if (item.sIndex !== 0) {
          result.unshift(
            buildUrlMessageBody({
              content: con.substring(0, item.sIndex),
              url: undefined,
              type: MessageCardType.Text,
              startIndex: 0,
              ext: undefined
            })
          );
        }
      } else {
        const textIdx = subIndexArr[idx - 1].eIndex;
        // console.log('中间段文本', con.substring(textIdx, item.sIndex));
        result.push(
          buildUrlMessageBody({
            content: con.substring(textIdx, item.sIndex),
            url: undefined,
            type: MessageCardType.Text,
            startIndex: textIdx,
            ext: undefined
          })
        );
        result.push(
          buildUrlMessageBody({
            content: con.substring(item.sIndex, item.eIndex),
            url: con.substring(item.sIndex, item.eIndex),
            type: MessageCardType.ShortLink,
            startIndex: item.sIndex,
            ext: undefined
          })
        );
      }
    });
    const lastItem = subIndexArr[subIndexArr.length - 1];
    if (lastItem.eIndex < content.length) {
      result.push(
        buildUrlMessageBody({
          content: con.substring(lastItem.eIndex, content.length),
          url: undefined,
          type: MessageCardType.Text,
          startIndex: lastItem.eIndex,
          ext: undefined
        })
      );
    }
  }
  return result;
}

export function parseExtraContentToArray(message: any) {
  const { content, intentData } = message;
  let sIdx = 0;
  const len = content.length;
  let newContent: ContentItem[] = [];
  if (intentData?.extraInfo?.length) {
    intentData?.extraInfo.forEach((item: any) => {
      if (item?.length === 2) {
        if (sIdx < item[0]) {
          newContent.push(
            buildUrlMessageBody({
              content: content.substring(sIdx, item[0]),
              url: "",
              type: MessageCardType.Text,
              startIndex: sIdx,
              ext: undefined
            })
          );
        }
        const endIdx = item[1] + 1;
        newContent.push(
          buildUrlMessageBody({
            content: content.substring(item[0], endIdx),
            url: "",
            type: MessageCardType.UserLink,
            startIndex: item[0],
            ext: undefined
          })
        );
        sIdx = endIdx;
      }
    });
    if (sIdx < len) {
      newContent.push(
        buildUrlMessageBody({
          content: content.substring(sIdx),
          url: "",
          type: MessageCardType.Text,
          startIndex: sIdx,
          ext: undefined
        })
      );
    }
  } else {
    newContent.push(
      buildUrlMessageBody({
        content: content.substring(0, len),
        url: "",
        type: MessageCardType.Text,
        startIndex: sIdx,
        ext: undefined
      })
    );
  }
  return newContent || [];
}

export const preivewFileWPS = (previewParams: any, options: any) => {
  getWpsPreviewCode(previewParams).then((res) => {
    if (res) {
      openJoyspacePreview({
        host: options.joyspaceHost,
        code: res.code,
        isShowHeader: 1,
        canSaveToJoyspace: false,
        canEdit: false,
        canForward: false,
        canDownload: false
      });
    } else {
      toast.error(res[1] || "网络异常");
    }
  });
};

/**
 * 发送消息
 */
/**
 * 将消息里的joyspace链接替换标题，ext填充文档信息
 */
export async function contentArrayReplaceJoyspaceTopic(
  arr: ContentItem[] = [],
  // tmpArr: ContentItem[] = [],
  sessions: Session[] = []
) {
  if (!arr.length) {
    return [];
  }
  const ids = arr.map((item: ContentItem) => {
    return JSON.parse(item?.ext || "{}").pageId;
  });
  let user: any[] = [];
  let groups: any[] = [];
  for (let item of sessions) {
    // console.log(item, 'sadsadsasdadssadadad');
    const info: any = item.info;
    if (item.isGroup) {
      groups.push({ gid: info.gid, permission_type: 2 });
    } else if (item.isSingle) {
      // console.log(info, 'infoinfoinfoinfoinfoinfoinfo=>');
      user.push({ userId: info.userId, teamId: info.teamId, permission_type: 2 });
    }
  }
  // console.log(ids, user, groups, 'contentArrayReplaceJoyspaceTopic=====>');
  const result = await shareJoyspaceFiles({
    page_ids: ids,
    to_eepaas_users: user,
    to_groups: groups
  });
  return result;
}
function getDisplayContentArr(contentArr = [], joyspaceAll: any) {
  return contentArr.map((item: ContentItem) => {
    if (item.type === MessageCardType.JoyspaceTopic) {
      item.ext = JSON.parse((item as any).ext);
      const pageId = (item.ext as any).pageId;
      const page = joyspaceAll?.[pageId]?.page;
      // let _item: any;
      // if (!page) {
      //   _item = buildUrlMessageBody({
      //     content: item.content,
      //     url: item.content,
      //     type: MessageCardType.ShortLink,
      //     startIndex: item.startIndex,
      //     ext: undefined
      //   });
      //   return _item;
      // }
      // page有文档信息 但是包含删除无权限
      const _ext: any = item.ext;
      _ext.currentPermission = -1;
      _ext.permission = -1;
      _ext.iconUrl = page?.icon_url || _ext?.iconUrl;
      _ext.title = page?.title || _ext?.title;
      if (Array.isArray(page?.permissions)) {
        _ext.currentPermission = 2;
        _ext.permission = page.permissions.includes(PermissionEnum.PAGE_EDIT) ? 1 : 2; // 默认 -1v
      }
      item.content = page?.title || _ext?.title;
      item.ext = _ext;
    }
    if (item.ext) {
      item.ext = JSON.stringify({ ...(item as any).ext });
      // console.log(JSON.parse(item.ext), 'itemitemitemitem=>');
    }
    return item;
  });
}

/**
 * 将消息里的joyspace链接替换标题
 */
export async function sendMessageBody(
  content: any,
  sessions: Session[] = [],
  isOutApp = false,
  data = {}
) {
  let contentArr: any = convertContentToArray(content, data);
  contentArr = contentArr.map((item: ContentItem) => {
    if (item.type === MessageCardType.ShortLink) {
      const _item = isOutApp || checkJoyspaceLink(item.content);
      // 是否是joyspace链接
      if (_item.is) {
        item.url = item.content;
        item.type = MessageCardType.JoyspaceTopic;
        item.ext = JSON.stringify({
          ..._item,
          pageId: _item.fileId,
          currentPermission: -1,
          permission: -1,
          title: "无标题",
          iconUrl: ""
        });
        // ext：{pageId, currentPermission(1可编辑 2仅阅读 -1无权限或者已删除), iconUrl, permission(1可编辑 2仅阅读 -1无权限或者已删除), title}
      }
      // 是否是Http链接,再次扩展
    }
    return item;
  });
  const joyspaceLinkArr = contentArr.filter(
    (item: ContentItem) => item.type === MessageCardType.JoyspaceTopic
  );
  // 请求Joyspace批量接口
  const joyspaceAll = await contentArrayReplaceJoyspaceTopic(joyspaceLinkArr, sessions);
  const _contentArr = getDisplayContentArr(contentArr, joyspaceAll);
  // console.log(_contentArr, 'contentArrcontentArrcontentArr');
  return _contentArr;
}

/**
 *
 * @param message 消息体
 * @param options 人员id或者组id
 * @param type 消息类型
 * @param permissionType 保留参数
 * @returns Object
 */
export async function forwardJoySpaceCard(
  message: any,
  options: any,
  type: ChatMessageType,
  permissionType = 2
) {
  // console.log(message, 'messagemessagemessagemessage');
  if (
    !message.displayContent &&
    type !== ChatMessageType.JOYSPACEFILE &&
    type !== ChatMessageType.JOYSPACEFOLDER
  ) {
    // eslint-disable-next-line no-debugger
    // debugger;
    return {};
  }
  let users: Array<any> = [];
  (options.uids || []).forEach((user: any) => {
    users.push({
      userId: user.pin,
      teamId: user.teamId,
      permission_type: 2
    });
  });
  let groups: Array<any> = [];
  (options.gids || []).forEach((id: any) => {
    groups.push({ gid: id, permission_type: 2 });
  });
  let pageIds = [];
  let folderIds: any[] = [];
  switch (type) {
    case ChatMessageType.JOYSPACEFILE:
      pageIds = [message?.fileId];
      break;
    case ChatMessageType.JOYSPACEFOLDER:
      folderIds = [message?.fileId];
      break;
    case ChatMessageType.TEXT:
      for (let item of message.displayContent) {
        if (item.type === MessageCardType.JoyspaceTopic && item.ext) {
          const ext = JSON.parse(item.ext);
          pageIds.push(ext.pageId);
        }
      }
      break;
    default:
      pageIds = [];
  }
  const result = await shareJoyspaceFiles({
    page_ids: pageIds,
    folder_ids: folderIds,
    to_eepaas_users: users,
    to_groups: groups
  });
  console.log(result, type, "===asdasdasd");
  if (type === ChatMessageType.JOYSPACEFILE) {
    const isDelPage = !Array.isArray(result[pageIds[0]].page.permissions);
    return {
      currentPermission: isDelPage ? -1 : 2,
      permission: isDelPage ? -1 : (message as any).permission
    };
  }

  if (type === ChatMessageType.JOYSPACEFOLDER) {
    const isDelPage = !Array.isArray(result[folderIds[0]].folder.permissions);
    return {
      currentPermission: isDelPage ? -1 : 2,
      permission: isDelPage ? -1 : (message as any).permission
    };
  }
  if (type === ChatMessageType.TEXT) {
    const _displayContent: any = JSON.parse(JSON.stringify(message.displayContent)); // 深克隆数组 否则会影响原消息
    const displayContent = getDisplayContentArr(_displayContent, result);
    console.log(displayContent, "displayContent===>", _displayContent, result);
    return { displayContent };
  }
}

/**
 * 当文档解析失败将
 * joySpaceLink消息转text消息
 */
export async function nonExistentPageToText(messageTypeOption: MessageTypeOption) {
  // console.log(messageTypeOption, 'messageTypeOptionmessageTypeOption');
  const { type, fileId } = messageTypeOption as any;
  if (type === ChatMessageType.JOYSPACEFILE) {
    const result = await getPageStatus([fileId]); // -2 文档不存在
    if (result[fileId] === -2) {
      (messageTypeOption as any).type = ChatMessageType.TEXT;
      return messageTypeOption;
    }
  }
  return messageTypeOption;
}

/**
 * 根据文本获取消息类型
 * @param text
 * @returns
 */
export interface TextTypeOption {
  type: string;
}

export interface HttpCardLinkTypeOption extends TextTypeOption {
  nativeId: string;
  data: { fileName: string; fileContent: string; webUrl: string; iconUrl?: string };
}
export interface JouspaceLinkTypeOption extends TextTypeOption {
  url: string;
  webUrl: string;
  fileId: string;
  pageType: number;
}

type MessageTypeOption = Readonly<TextTypeOption | JouspaceLinkTypeOption | HttpCardLinkTypeOption>;

export function getDisplayLink(content: string, displayContent: any) {
  const matchUrls = content.match(urlPatt) || [];
  if (!matchUrls?.length || !displayContent?.length) {
    return [
      {
        type: MessageCardType.Text,
        content
      }
    ];
  } else {
    let newContent = content;
    let result: any[] = [];
    matchUrls.forEach((url: any) => {
      const index = newContent.indexOf(url);
      if (index > 0) {
        result.push({
          type: MessageCardType.Text,
          content: newContent.substring(0, index)
        });
        newContent = newContent.substring(index + url.length);
      } else {
        newContent = newContent.substring(url.length);
      }
      const target = displayContent?.find(
        (item: any) =>
          (item.type === MessageCardType.HttpTopic ||
            item.type === MessageCardType.JoyspaceTopic ||
            item.type === MessageCardType.ShortLink) &&
          item.url === url
      );
      result.push(target);
    });
    if (newContent) {
      result.push({
        type: MessageCardType.Text,
        content: newContent
      });
    }
    return result;
  }
}

export async function getMessageTypeByText(
  text: string,
  matchList: any,
  blackList: any,
  isOutApp = false,
  isQuillMsg?: boolean
): Promise<MessageTypeOption> {
  const matchUrls = text.match(urlPatt) || [];
  let url = "";
  let result;
  let isMatchLink = false;
  let isBlackLink = false;
  if (matchUrls.length === 1) {
    url = matchUrls[0];
    // 跨租户 跨人员 joyspace链接不识别卡片 & 富文本不转joyspacefile类型
    if (!isOutApp) {
      result = checkJoyspaceLink(url);
    }
    // for (let item of matchList) {
    //   const reg = new RegExp(`^https?:\/\/${item}`);
    //   isMatchLink = reg.test(url);
    //   if (isMatchLink) {
    //     break;
    //   }
    // }
    if (blackList?.length) {
      for (let item of blackList) {
        const reg = new RegExp(`^https?:\/\/${item}`);
        isBlackLink = reg.test(url);
        if (isBlackLink) {
          break;
        }
      }
    }
  }
  const typeOption = { type: ChatMessageType.TEXT };
  if (result?.is) {
    if (isQuillMsg) {
      return typeOption;
    }
    return {
      type: ChatMessageType.JOYSPACEFILE,
      ...result
    };
  }

  // 新版本去掉message.type = text，nativeId = share_link 的http链接消息卡片类型
  // 如果输入内容是一个纯微信公众号链接（mp.weixin.qq.com，按照这个域名匹配），则按照卡片方式发送，其余按照文本消息发送。
  if (url && !isBlackLink && !isOutApp) {
    const [data, error] = await getTitleByCardConvertLink(url);
    if (data) {
      return {
        ...typeOption,
        nativeId: url === text ? "share_link" : "",
        data: {
          fileName: (data as any).postTitle,
          fileContent: (data as any).desc,
          iconUrl: (data as any).icon,
          webUrl: url
        }
      };
    }
  }
  return typeOption;
}

export function getRevokeMessageDesc(
  message: any,
  sessionType: SessionType,
  currentEmployee: Employee
): string {
  if (!message) {
    return "";
  }
  const isEqualuser = isEqualEmployee(message?.sender, message?.revoker);
  if (mySendMessage({ message, currentEmployee }) && (!message.revoker || isEqualuser)) {
    return i18n.t("chat:you_revoke_message");
  } else if (sessionType === SessionType.SINGLE || sessionType === SessionType.SECRET_SINGLE) {
    return i18n.t("chat:other_revoke_message");
  } else if (sessionType === SessionType.GROUP) {
    if (message?.revoker && !isEqualuser) {
      if (isEqualEmployee(currentEmployee, message?.revoker)) {
        return i18n.t("chat:admin revoke message", {
          operator: "您",
          sender: message?.sender.name
        });
      } else if (isEqualEmployee(currentEmployee, message?.sender)) {
        return i18n.t("chat:admin revoke message", {
          operator: message?.revoker?.name,
          sender: "您"
        });
      } else {
        return i18n.t("chat:admin revoke message", {
          operator: message?.revoker?.name,
          sender: message?.sender.name
        });
      }
    } else {
      return i18n.t("chat:someone-revoke-message", { name: message?.sender?.name || "" });
    }
  } else {
    return "";
  }
}

export function removeFirstOccurrence(str: string, pattern: string) {
  const regex = new RegExp(`^${pattern}`, "");
  return str.replace(regex, "").trim();
}

function buildTitle(type: string, content: string): string {
  return `[${type}] ${content}`;
}

export function getMsgContent(message: any, keyWord: string) {
  let title = "";
  if (message.type === ChatMessageType.TEMPLATE2) {
    const { sharelink, sharecard, noteShare } = message.data[0] || {};
    const { nativeId } = message.template || {};
    const parseUrl = DeeplinkEvent.parseDeeplink(message.data[0]?.sharelink?.url);
    let content = sharelink?.content || "";
    if (parseUrl?.pathname === DeeplinkPathEnum.Schedule_Draw) {
      title = content
        ? buildTitle("日程分享", content.split("开始时间")[0])
        : i18n.t("chat:share-links");
    } else if (parseUrl?.pathname === DeeplinkPathEnum.Task_Draw) {
      title = buildTitle("任务分享", sharelink?.content || "");
    } else if (nativeId === "share_card") {
      title = buildTitle("名片分享", sharecard?.realName || sharecard?.nickName);
    } else if (nativeId === "merge_forward") {
      title = buildTitle("沟通记录", `（包含：${keyWord}）`);
    } else if (nativeId === "note_share" || nativeId === "meetinglive_pull") {
      title = buildTitle(i18n.t("chat:meeting_summary_card"), noteShare?.topic);
    } else if (nativeId === "common_card") {
      const cardName = message.data[0]?.common_card?.applicationName || "卡片";
      title = buildTitle(cardName, `（包含：${keyWord}）`);
    }
  } else {
    switch (message.type) {
      case ChatMessageType.FILE:
      case ChatMessageType.EGOV_FILE:
        title = buildTitle("文件", message.name);
        break;
      case ChatMessageType.LOCATION:
      case ChatMessageType.LOCATION_JD:
        title = buildTitle("位置", message.title);
        break;
      case ChatMessageType.GROUPNOTICE:
        title = buildTitle("群通知", message.content);
        break;
      case ChatMessageType.JOYSPACEFILE:
        title = buildTitle("文档协同", message?.name || message?.fileName);
        break;
      case ChatMessageType.SOLITAIRE:
        title = buildTitle("群接龙", message.content);
        break;
    }
  }
  return title;
}

// eslint-disable-next-line max-params,complexity
export function getLastMessageDesc(
  message: any,
  sessionType: SessionType,
  currentEmployee: Employee,
  isNotice?: boolean,
  session?: Session
): string {
  if (!message) {
    return "";
  }

  if (message.revoke > 0) {
    return getRevokeMessageDesc(message, sessionType, currentEmployee);
  }
  if (message.type === "unified_notice_message") {
    // 群组手
    if (message.from?.pin === "eopen-push_uUyYexheoyRkjp6DpVtx") {
      return userEscapeString(message.title);
    }
    // 新用户申请
    if (message.from?.pin === "eopen-push_yQXxq4WhIpF2CAdw01Ti") {
      return userEscapeString(message.title);
    }
    if (!isShowOldNoticeCard(message)) {
      return userEscapeString(message.title);
    }
    if (message.pin === CHAT_NOTICE.AI_PIN) {
      return userEscapeString(message.content);
    }
    return userEscapeString(message.content);
  }
  if (isGroupCleanMessage(message)) {
    return userEscapeString(message.content);
  }
  if (sessionType === SessionType.SECRET_SINGLE && message?.expire) {
    return "[消息]";
  }
  if (message?.type) {
    let content = "";
    let hasRemark = false;
    const tipRich = i18n.t("chat:quill-old-version-tip");
    switch (message.type) {
      case "revoke_message":
        content = getRevokeMessageDesc(message, sessionType, currentEmployee);
        return content;
      case ChatMessageType.JOYSPACEFILE:
        if (message.content === message.webUrl) {
          content = `[${i18n.t("chat:document")}]:${
            message.fileName ? message.fileName : "无标题"
          }`;
        } else if (message.content) {
          content = message.content.replace(urlReg, `[${i18n.t("chat:link")}]`);
        }
        break;
      case ChatMessageType.JOYSPACEFOLDER:
        if (message.content === message.webUrl) {
          content = `[${i18n.t("chat:folder")}]:${message.fileName ? message.fileName : "无标题"}`;
        } else if (message.content) {
          content = message.content.replace(urlReg, `[${i18n.t("chat:link")}]`);
        }
        break;
      case ChatMessageType.TEXT:
        if (message.atUsers) {
          for (let atUser of message.atUsers) {
            if (atUser.remark) {
              hasRemark = true;
              break;
            }
          }
        }
        content =
          session && (isShowAlias(session) || hasRemark) && message.atContent
            ? `${message.atContent}`
            : `${message.content}`;
        if (message?.quillImage?.length) {
          content = removeFirstOccurrence(content, tipRich);
        }
        // 卡片链接
        if (message?.displayContent?.length) {
          content = message?.displayContent?.reduce((a: any, txt: any) => {
            return `${a}${(txt?.type || "") === MessageCardType.HttpTopic ? "[链接]" : ""}${
              removeFirstOccurrence(txt?.content, tipRich) || ""
            }`;
          }, "");
        }
        break;
      case ChatMessageType.IMAGE:
        content = `[${i18n.t("chat:image")}]`;
        break;
      case ChatMessageType.VOICE:
        // content = `[${i18n.t('chat:no_support_message_type')}]`;
        content = `[${
          (message?.voiceType || 0) === 1 ? i18n.t("chat:intercomVoice") : i18n.t("chat:voice")
        }]`;
        break;
      case ChatMessageType.VIDEO:
        content = `[${i18n.t("chat:video")}]`;
        break;
      case ChatMessageType.FILE:
        content = `[${i18n.t("chat:file")}]${message.name}`;
        break;
      case ChatMessageType.EGOV_FILE:
        content = `[${i18n.t("chat:file")}]${message.name}`;
        break;
      case ChatMessageType.GROUPNOTICE:
        content = "[群通知]";
        break;
      case ChatMessageType.TEMPLATE2:
        if (message?.template?.nativeId === "merge_forward") {
          content = `[${i18n.t("chat:communicate_record")}]`;
          // content = `[${i18n.t('chat:no_support_message_type')}]`;
        } else if (message?.template?.nativeId === "share_card") {
          content = `[${i18n.t("chat:user_card")}]`;
          // if (sessionType === SessionType.GROUP) {
          //   content = `[${i18n.t("chat:user_card")}]`;
          // } else if (mySendMessage({ message, currentEmployee })) {
          //   content = `[${i18n.t("chat:user_card")}]`;
          // } else {
          //   let name = ":";
          //   if (message.sender) {
          //     name = (message.sender?.name || "") + name;
          //   } else if (message.body) {
          //     name = (message.body.sender?.name || "") + name;
          //   }
          //   const second = get(message, "data.0.sharecard.nickName", "");
          //   content = `${i18n.t("chat:share_card_desc", { name, second })}`;
          // }
        } else if (message?.template?.nativeId === "meetinglive_pull") {
          const meetinglive_pull = message.data[0]?.meetinglive_pull || {};
          const sharerName = meetinglive_pull.sharerName;
          content = `${i18n.t("chat:meeting_live_card", { sharerName })}`;
        } else if (message?.template?.nativeId === "note_share") {
          content = `[${i18n.t("chat:meeting_summary_card")}]${message.data[0]?.noteShare?.topic}`;
        } else if (message?.template?.nativeId === "common_card") {
          const common_card = message.data[0]?.common_card || {};
          content = `[${common_card.applicationName}]${common_card.title}`;
        } else if (message?.template?.nativeId === "share_multi_image_txt") {
          const title =
            get(message, "data.0.orgNumberCard.title", "") ||
            get(message, "data.0.title", "") ||
            get(message, "data.0.content", "") ||
            get(message, "data.0.orgNumberCard.content", "") ||
            "";
          content = `${title}`;
        } else {
          const title = get(message, "data.0.sharelink.title", "");
          content = `[${i18n.t("chat:link")}]${title}`;
        }
        break;
      case ChatMessageType.SOLITAIRE:
        content = "[群接龙]";
        break;
      case "group_delete":
        content = "群已解散";
        break;
      case ChatMessageType.LOCATION_JD:
        content = `[${i18n.t("chat:location_jd")}]${message.title}`;
        break;
      case ChatMessageType.INVITE_FORWARD:
        return "";
      default:
        content = `[${i18n.t("chat:no_support_message_type")}]`;
        break;
    }
    if (message.type === ChatMessageType.SYS) {
      if (message.flag === 100) {
        content = message.content;
      } else if (message.sys_msg_type === "SetRosterSuccessNotice") {
        content = message.content;
      }
      content = userEscapeString(content);
    } else if (isNotice) {
      // 转换咚咚表情
      content = userEscapeString(content);
      content = convertStringToNoticeEmoji(content);
    } else {
      content = userEscapeString(content);
      content = mattchEmoji(convertStringToEmoji(stringEncode(content)));
    }

    if (content && sessionType === SessionType.GROUP) {
      let name = "";
      let alias = "";
      const sender = message.sender || message.body.sender;
      if (!isEqualEmployee(sender, currentEmployee)) {
        name = (sender?.name || "") + name;
        alias = getUserAlias(sender, session) + alias;
      }
      alias = alias && alias !== "undefined" ? `（${alias}）` : "";
      content = `${name ? `${name}${alias}：` : ""}${content}`;
    }
    return content;
  } else {
    // 辅助消息提示
    return "";
  }
}

export function isEqualApp(
  employeeI: Employee | EmployeeAttribute,
  employeeII: Employee | EmployeeAttribute
): boolean {
  return employeeI.app === employeeII.app;
}

export function isEqualTeam(
  employeeI: Employee | EmployeeAttribute,
  employeeII: Employee | EmployeeAttribute
): boolean {
  return employeeI.teamId === employeeII.teamId;
}

export function isEqualEmployee(
  employeeI: Employee | EmployeeAttribute,
  employeeII: Employee | EmployeeAttribute
): boolean {
  if (!employeeI) {
    return false;
  }
  if (!employeeII) {
    return false;
  }
  return (
    employeeI.app === employeeII.app &&
    employeeI.userId === employeeII.userId &&
    employeeI.teamId === employeeII.teamId
  );
}

export function isEqualUid(uidI: UID, uidII: UID): boolean {
  return (
    uidI &&
    uidII &&
    uidI.app === uidII.app &&
    uidI.pin === uidII.pin &&
    uidI.teamId === uidII.teamId
  );
}

export function isSameApp(
  user: { app?: string; ddAppId?: string },
  employee: { app?: string; ddAppId?: string }
): boolean {
  return (user.app || user.ddAppId) === (employee.app || employee.ddAppId);
}

export function isGroupMemberDeleteMessage(message: any) {
  return message.type === MessageRespType.GROUP_MEMBER_DELETE;
}

export function isGroupMemberInMessage(message: any) {
  return message.type === MessageRespType.GROUP_MEMBER_IN;
}

export function isGroupBotStopMessage(message: any) {
  return message.type === MessageRespType.GROUP_BOT_STOP;
}

/**
 * 是不是系统类消息
 * @param message
 */
export function isSysMessage(message: any): boolean {
  return message && message.type === ChatMessageType.SYS;
}

export function isGroupNoticeMsg(message: any): boolean {
  return message && message.from.pin === "eopen-push_gc1EijDXzxUehGW1ydK5";
}
export function isSysNoticeMsg(message: any): boolean {
  return message && message.from.pin === "eopen-push_9IdJIcxdZmWRmXNLw3Qc";
}

export function isRevokeMessage(message: any): boolean {
  return message && message.revoke === 1;
}

export function isDownloadSysMesssage(message: any): boolean {
  return message && message.category === MessageEmitCategory.SYSTEM && message.flag === 1;
}

export function isSnapchatTimeSysMesssage(message: any): boolean {
  return message && message.category === MessageEmitCategory.SYSTEM && message.flag === 3;
}

export function isUnreadSummarySysMesssage(message: any): boolean {
  return (
    message && message.category === MessageEmitCategory.SYSTEM && message.type === "MESSAGE_SUMMARY"
  );
}

/**
 * 是否通知类消息
 * @param message
 */
export function isNoticeMessage(message: any): boolean {
  return message && message.type === "unified_notice_message";
}

/**
 * 检验是否为AI助手的子会话消息
 * @param chatMessage
 * @param customAppList // 自定义独立会话消息列表
 * @returns boolean
 */
export function isAINoticeChildSessionMessage(chatMessage: any, customAppList: Session[]) {
  let noticeId = chatMessage.infox?.noticeId || chatMessage.from.pin;
  chatMessage.info = {
    userId: noticeId
  };
  const isCustomApp = isCustomAppSession(chatMessage as any, customAppList);
  return (
    noticeId !== CHAT_NOTICE.SYS_PIN &&
    noticeId !== CHAT_NOTICE.ANNOUNCEMENT_PIN &&
    noticeId !== CHAT_NOTICE.AI_PIN &&
    !isCustomApp &&
    chatMessage.type === "unified_notice_message"
  );
}

/**
 * 是不是已读的消息
 * @param message
 * @param currentEmployee
 */
export function isReadMessage(message: any, currentEmployee: Employee, lastMsg: any): boolean {
  // console.log('已读未读', message, lastMsg);
  if (mySendMessage({ message, currentEmployee }) && !message.revoke) {
    if (message?.readUids && message.readUids.length > 0) {
      const index = message.readUids.findIndex((item: any) => {
        return !isEqualUid(item, employeeToUid(currentEmployee));
      });
      return index > -1;
    }
    if (lastMsg.timestamp > message.timestamp && lastMsg?.readUids && lastMsg.readUids.length > 0) {
      return true;
    }
  }
  if (
    lastMsg &&
    !isEqualEmployee(lastMsg.sender, currentEmployee) &&
    lastMsg.timestamp > message.timestamp
  ) {
    return true;
  }
  return false;
}

/**
 * 获取单聊的对方用户信息
 */
export function getSingleInfo(session: Session): Employee | null {
  if (session.isSingle) {
    return session.info as Employee;
  }
  return null;
}

/**
 * 判断是不是外部联系人
 */
export function isOuterContacts(session: Session, currentEmployee: Employee) {
  const info = getSingleInfo(session);
  if (info) {
    return !isSameApp(info, currentEmployee);
  }
  return false;
}

/**
 * 转  uid
 * @param employee
 */
export function employeeToUid(employee: Employee | EmployeeAttribute): UID {
  return {
    app: employee?.app,
    pin: employee?.userId,
    teamId: employee?.teamId
  };
}

/**
 * 转 Employee
 * @param uid
 */
export function uidToEmployee(uid: UID): Partial<Employee> {
  return {
    app: uid?.app,
    userId: uid?.pin,
    teamId: uid?.teamId
  };
}

export function setMessageGroupId(
  message: ChatMessage,
  prevMessage: ChatMessage | null
): ChatMessage {
  if (prevMessage) {
    let { sender, groupId, timestamp, category } = prevMessage;
    // 是同一个人发送且在 1 (可配置) 分钟之内的，标识为一个分组
    if (
      isEqualEmployee(message.sender, sender) &&
      Math.abs(message.timestamp - timestamp) < 60 * 1000 &&
      groupId &&
      category !== "system"
    ) {
      // 如果消息里有to(会议私聊)，除了上面的判断条件，再加一个私聊对象的判断
      // (1)都私聊且不是一个人 (2)一个私聊一个所有人
      if (
        (message?.to && message?.to?.pin !== prevMessage?.to?.pin) ||
        (!message?.to && prevMessage?.to) ||
        (message?.to && !prevMessage?.to)
      ) {
        message.groupId = message.id;
      } else {
        message.groupId = groupId;
      }
    } else {
      message.groupId = message.id;
    }
    return message;
  }
  message.groupId = message.id;
  return message;
}

/**
 * 是否群管理员
 * @param session
 * @param currentEmployee
 */
// export function isGroupAdmin({
//     session,
//     currentEmployee,
// }: {
//     session: Session;
//     currentEmployee: Employee;
// }): boolean {
//     if (session.isGroup) {
//         const owner = (session.info as Group).owner || {};
//         const user = employeeToUid(currentEmployee);
//         return isEqualUid(owner, user);
//     }
//     return false;
// }

export function isGroupOwner({
  session,
  currentEmployee
}: {
  session: Session;
  currentEmployee: Employee | EmployeeAttribute;
}): boolean {
  if (session.isGroup) {
    const owner = (session.info as Group).owner || {};
    const user = employeeToUid(currentEmployee);
    return isEqualUid(owner, user);
  }
  return false;
}

/**
 * 是否是群管理员
 * @param groupRosters
 * @param currentEmployee
 */
export function isGroupAdmin(groupRosters: Partial<GroupRoster>[], currentEmployee: Employee) {
  const roster = (groupRosters || []).find((item) => {
    if (item.info) {
      return isEqualEmployee(item.info, currentEmployee);
    }
    return false;
  });
  return ["administrator", "sub_administrator"].includes(roster?.identity || "");
}

/**
 * 在群里的身份角色
 * @param identity
 * @returns
 */
export function getRole(identity: string) {
  if (identity === "sub_administrator") {
    return "群管理员";
  } else if (identity === "administrator") {
    return "群创建人";
  }
  return "群成员";
}

/**
 * 是否被邀请者
 * @param session
 * @param currentEmployee
 */
export function isInvitee({
  message,
  currentEmployee
}: {
  message: any;
  currentEmployee: Employee;
}): boolean {
  const members = message.members;
  if (members && members.length > 0) {
    const index = message.members.findIndex((item: any) => {
      return isEqualUid(item, employeeToUid(currentEmployee));
    });
    return index > -1;
  }
  return false;
}

export function toMe({ session, employee }: { session: Session; employee: Employee }) {
  if (session.isSingle) {
    const info = session.info as Employee;
    return isEqualEmployee(info, employee);
  } else {
    return false;
  }
}

export function isSameTeam({ session, employee }: { session: Session; employee: Employee }) {
  if (session.isSingle) {
    const info = session.info as Employee;
    return info.teamId === employee.teamId;
  } else {
    return false;
  }
}

/**
 * 获取消息发送方
 * @param chatMessage
 * @param employee
 * @param session
 */
export const getMessageSendType = (
  { sender }: ChatMessage,
  employee: Employee,
  session?: Session
): MessageSendType => {
  let _employee = employee;
  // 当前用户未获取到数据兼容
  if (!_employee?.userId) {
    _employee = getCurrentUserFromLocal() as Employee;
  }
  if (isEqualEmployee(sender, _employee)) {
    if (session && [SessionType.SINGLE, SessionType.SECRET_SINGLE].includes(session.sessionType)) {
      const info = session.info as Employee;
      if (isEqualEmployee(info, _employee)) {
        // 自已给自已发
        return MessageSendType.SELF;
      }
    }
    return MessageSendType.OWNER;
  } else {
    return MessageSendType.OTHER;
  }
};

export const getCurrentUserFromLocal = () => {
  let config = FocusSDK.getConfigData() || "" ? JSON.parse(FocusSDK.getConfigData()) : {};
  let userCache = config?.userCache;
  if (!userCache && config.auth) {
    userCache = { ...config.auth.teamUserInfo, userId: config.auth.userId };
  }
  if (userCache) {
    return {
      userId: userCache.userId,
      teamId: userCache.teamId,
      app: userCache.ddAppId,
      nickName: userCache.realName,
      name: userCache.realName,
      avatar: userCache.headImg
    };
  } else {
    return {};
  }
};

export function senderIsInvitee({ message }: { message: any }) {
  if (message.type === "group_member_in" && message.invitees && message.invitees.length === 1) {
    const { sender, invitees } = message;
    return isEqualUid(employeeToUid(sender), invitees[0]);
  }
  return false;
}

/**
 * 我发送的消息
 * @param message
 * @param currentEmployee
 */
export function mySendMessage({
  message,
  currentEmployee
}: {
  message: any;
  currentEmployee: Employee;
}) {
  return isEqualEmployee(message?.sender, currentEmployee);
}

/**
 * 我接收的消息
 * @param message
 * @param currentEmployee
 */
export function myReceiveMessage({
  message,
  currentEmployee
}: {
  message: any;
  currentEmployee: Employee;
}) {
  return isEqualEmployee(message.to || {}, currentEmployee);
}

// eslint-disable-next-line max-params
export function checkGroupSysMessage({ message }: { message: any }): any {
  const sysMsgGroupConfig: any = sysMsgConfig["system-message-group"];
  const receiveRoles = sysMsgGroupConfig[message.type];
  if (message.type === MessageRespType.GROUP_SET) {
    // 如果是群设置的消息通知 检查一下 是否有相关配置接收用户
    if (!combGroupSetField(message)) {
      return null;
    }
  }
  if (isGroupCleanMessage(message)) {
    return message;
  }
  // 邀请新人入群并分享聊天记录
  if (message.type === MessageRespType.INVITE_FORWARD) {
    return message;
  }
  // 撤回新人入群分享的聊天记录
  if (message.type === MessageRespType.INVITE_REVOKE) {
    return message;
  }
  if (message.flag === 1 || message.flag === 99 || message.flag === 32) {
    return message;
  }
  if (!receiveRoles) {
    // 没有配置项，群里任何角色都不可以接收这个系统消息
    return null;
  }
  return message;
}

export function checkSingleSysMessage({ message }: { message: any }) {
  return message;
}

export function checkMeetingSysMessage({ message }: { message: any }) {
  if (message && message.flag === 100) {
    return true;
  }
  return false;
}

export function checkNoticeSysMessage({ message }: { message: any }) {
  return message;
}

export function checkSysMessage({ message, session }: { message: any; session: Session }): any {
  if (session.isGroup) {
    // 判断 群聊 系统类消息显示权限
    return checkGroupSysMessage({ message });
  } else if (session.isSingle && !session.isNotice) {
    // 判断 单聊 系统类消息显示权限
    return checkSingleSysMessage({ message });
  } else if (session.isNotice) {
    return checkNoticeSysMessage({ message });
  }
  return null;
}

// eslint-disable-next-line complexity
export function getReplyMessageDesc(message: ChatMessage, session: Session) {
  let content = "";
  switch (message.type) {
    case ChatMessageType.TEXT:
      content =
        isShowAlias(session) && (message as any).atContent
          ? `${(message as any).atContent}`
          : FocusSDK.isPrivateNet() && message?.data?.egovWebUrl
          ? message.data.egovWebUrl
          : message?.data?.webUrl || message.content;
      if (message?.quillImage?.length) {
        content = removeFirstOccurrence(content, i18n.t("chat:quill-old-version-tip"));
      }
      break;
    case ChatMessageType.IMAGE:
      content = `[${i18n.t("chat:image")}]`;
      break;
    case ChatMessageType.VOICE:
      // content = `[${i18n.t('chat:voice')}]`;
      content = `[${i18n.t("chat:no_support_message_type")}]`;
      break;
    case ChatMessageType.VIDEO:
      content = `[${i18n.t("chat:video")}]`;
      break;
    case ChatMessageType.FILE:
      content = `[${i18n.t("chat:file")}]${shortFileName(message.name)}`;
      break;
    case ChatMessageType.EGOV_FILE:
      content = `[${i18n.t("chat:file")}]${shortFileName(message.name)}`;
      break;
    case ChatMessageType.JOYSPACEFILE:
      if (message.content === message.webUrl) {
        content = `[${i18n.t("chat:document")}]:${message.fileName}`;
      } else {
        const tempCon =
          isShowAlias(session) && (message as any).atContent
            ? (message as any).atContent
            : message.content;
        const _con = tempCon || message.webUrl || message.fileName || "";
        content = _con.replace(urlReg, `[${i18n.t("chat:link")}]`);
      }
      break;
    case ChatMessageType.JOYSPACEFOLDER:
      if (message.content === message.webUrl) {
        content = `[${i18n.t("chat:folder")}]:${message.fileName}`;
      } else {
        const _con = message.content || message.webUrl || message.fileName || "";
        content = _con.replace(urlReg, `[${i18n.t("chat:link")}]`);
      }
      break;
    case ChatMessageType.TEMPLATE2:
      if (message?.template?.nativeId === "merge_forward") {
        content = `[${i18n.t("chat:communicate_record")}]`;
      } else if (message?.template?.nativeId === "share_card") {
        content = `[${i18n.t("chat:user_card")}]`;
      } else if (message?.template?.nativeId === "meetinglive_pull") {
        const meetinglive_pull = (message as any).data[0]?.meetinglive_pull || {};
        let sharerName = meetinglive_pull.sharerName;
        content = `${i18n.t("chat:meeting_live_card", { sharerName })}`;
      } else if (message?.template?.nativeId === "common_card") {
        const common_card = (message as any).data[0]?.common_card || {};
        content = `[${common_card.applicationName}]${common_card.title}`;
      } else if (message?.template?.nativeId === "share_multi_image_txt") {
        const title = `[${i18n.t("chat:link")}]${
          get(message, "data.0.orgNumberCard.title", "") ||
          get(message, "data.0.title", "") ||
          get(message, "data.0.content", "") ||
          ""
        }`;
        content = `${title}`;
      } else {
        content = `[${i18n.t("chat:link")}]${get(message, "data.0.sharelink.title", "")}`;
      }
      break;
    case ChatMessageType.GROUPNOTICE:
      content = `[${i18n.t("chat:group-notice")}]`;
      break;
    case ChatMessageType.SOLITAIRE:
      content = "[群接龙]";
      break;
    case ChatMessageType.LOCATION_JD:
      content = `[${i18n.t("chat:location_jd")}]${message.title}`;
      break;
    default:
      content = `[${i18n.t("chat:no_support_message_type")}]`;
      break;
  }

  return mattchEmoji(convertStringToEmoji(stringEncode(content)));
}
// 检测是否是直播卡片
export function checkisLiveCard(message: ChatMessage) {
  /* 直播卡片：type为template2且nativeid为 meetinglive_pull | note_share */
  if (message.type === ChatMessageType.TEMPLATE2) {
    if (message?.template?.nativeId === "meetinglive_pull") {
      return true;
    }
  }
  return false;
}
export function checkIsSummaryCard(message: ChatMessage) {
  if (message.type === ChatMessageType.TEMPLATE2) {
    if (message?.template?.nativeId === "note_share") {
      return true;
    }
  }
  return false;
}

export function checkMessageSupport(message: ChatMessage) {
  // if ((message?.expire || 0) > 0) {
  //     return false;
  // }

  const supportConfig: any = {
    [ChatMessageType.TEXT]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_TEXT],
    revoke_message: config[ChatConfig.CHAT_MESSAGE_SUPPORT_REVOKE],
    [ChatMessageType.IMAGE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_IMAGE],
    [ChatMessageType.FILE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_FILE],
    [ChatMessageType.EGOV_FILE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_EGOV_FILE],
    [ChatMessageType.VOICE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_VOICE],
    [ChatMessageType.VIDEO]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_VIDEO],
    [ChatMessageType.TEMPLATE2]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_TEMPLATE2],
    [ChatMessageType.SYS]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_SYS],
    [ChatMessageType.JOYSPACEFILE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_JOYSPACE_FILE],
    [ChatMessageType.JOYSPACEFOLDER]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_JOYSPACE_FOLDER],
    [ChatMessageType.SOLITAIRE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_GROUPSOLITAIRE],
    [ChatMessageType.GROUPNOTICE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_GROUP_NOTICE],
    [ChatMessageType.LOCATION_JD]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_LOCATION_JD],
    [ChatMessageType.PERMISSION_CHANGE]: config[ChatConfig.CHAT_MESSAGE_SUPPORT_PERMISSION_CHANGE],
    unified_notice_message: config[ChatConfig.CHAT_MESSAGE_SUPPORT_NOTICE]
  };
  return supportConfig[message.type] || false;
}

export function sleep(ms: number) {
  return new Promise<void>(function (resolve) {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

export function checkSelectUserData(selectedResult: any) {
  return get(selectedResult, "data.result.0.origin.info.userId", "");
}

/**
 * 获取人员选择器， 选择的人员
 * 返回 app userId teamId
 * @param selectedResult 选择的结果集
 */
export function getInvitees(selectedResult: any): UID[] {
  const array = get(selectedResult, "data.result", []);
  if (array.length === 0) {
    return [] as UID[];
  }
  return array.map((item: any) => {
    const info = item?.origin?.info || item?.origin;
    return {
      ...info,
      ...{
        avatar: item.avatar,
        name: item.name,
        pin: info?.userId || info?.pin || item?.userId || item?.pin,
        app: info?.app || info?.appId || item?.app || item?.appId,
        teamId: item?.teamId || info?.teamId,
        userType: item?.userType || info?.userType
      }
    };
  });
}

/**
 * 构建群成员信息
 * @param rosters
 */
export function mapRosters(rosters: any): any {
  return rosters.map((item: any) => {
    const employeeExt = item.info?.employeeExt
      ? typeof item.info?.employeeExt === "string"
        ? JSON.parse(item.info?.employeeExt)
        : item.info?.employeeExt
      : {};
    const info = pick(item.info, [
      "app",
      "avatar",
      "name",
      "userId",
      "teamId",
      "accountType",
      "e_dept_full_name",
      "unitName",
      "unitDeptId",
      "deptId",
      "deptName",
      "titleName",
      "titleId",
      "labelInfoList"
    ]);
    return {
      identity: item.identity,
      alias: item.alias,
      info: {
        ...info,
        titleId: employeeExt.titleId,
        userType: employeeExt.userType,
        remark: employeeExt.remark
      },
      user: item.user
    };
  });
}

/**
 * 查找管理员
 * @param rosters
 */
export function getGroupAdmin(rosters: any): any {
  return (
    rosters.find((item: any) => {
      return item.identity === "administrator";
    })?.info || {}
  );
}

/**
 * 查找管理员位置
 * @param rosters
 */
export function getGroupOwnerIndex(rosters: any): any {
  return rosters.findIndex((item: any) => {
    return item.identity === "administrator";
  });
}

/**
 * 查找群成员位置
 */

/**
 * 查找管理员位置
 * @param rosters
 * @param currentEmployee
 */
export function getRosterIndex(rosters: any, currentEmployee: Employee): any {
  return rosters.findIndex((item: any) => {
    return isEqualEmployee(item.info, currentEmployee);
  });
}

/**
 * 变换管理员位置
 * @param groupRosters
 */
export function sortGroupRosters(groupRosters: any): any {
  const group = lodashGroupBy(groupRosters, "identity");
  // administrator: [{…}]
  // ordinary: (2) [{…}, {…}]
  // sub_administrator: (3) [{…}, {…}, {…}]
  return [
    ...(group.administrator || []),
    ...(group.sub_administrator || []),
    ...(group.ordinary || [])
  ];
}

/**
 * 变换管理员位置
 * @param groupRosters
 */
export function replaceGroupAdminIndex(groupRosters: any): any {
  const adminIndex = getGroupOwnerIndex(groupRosters);
  if (adminIndex > 0) {
    const admin = groupRosters[adminIndex];
    groupRosters[adminIndex] = groupRosters[0];
    groupRosters[0] = admin;
  }
  return groupRosters;
}

export function getSessionIndex(sessionList: any, session: any): any {
  return sessionList.findIndex((s: Session) => {
    return s.sessionId === session.sessionId;
  });
}

export function addOneSession(allSessionList: any, session: any) {
  const index = getSessionIndex(allSessionList, session);
  if (index >= 0) {
    allSessionList[index] = session;
  } else {
    allSessionList.unshift(session);
  }
  return allSessionList.sort((a: { timestamp: any }, b: { timestamp: any }) => {
    return (b.timestamp || 0) - (a.timestamp || 0);
  });
}

export function mapUserDataToUid(userData: UserCardData): UID {
  const fields = userData.fields || [];
  const avatarInfo = fields.find((item: any) => {
    return item.key === "avatar";
  });
  const nameInfo = fields.find((item: any) => {
    return item.key === "name";
  });
  return {
    app: userData.appId,
    pin: userData.userId,
    teamId: userData.teamId,
    avatar: avatarInfo?.val || "",
    name: nameInfo?.val || ""
  };
}

export function mapWebSearchDataToUid(data: any) {
  const userInfo = data.origin;
  return {
    app: userInfo.app,
    pin: userInfo.userId,
    teamId: userInfo.teamId,
    avatar: userInfo.avatar || "",
    name: userInfo.realName || ""
  };
}

export function mapDeskSearchDataToUid(data: any) {
  return {
    app: data.app,
    pin: data.userId,
    teamId: data.teamId,
    avatar: data.avatar || "",
    name: data.realName || ""
  };
}

/**
 * 判断是否是一端
 * @param message
 */
export function isSameClient(message: any) {
  const from = message.from || {};
  if (from.clientType) {
    return (
      from.clientType === ClientType.IPAD ||
      from.clientType === ClientType.MAC ||
      from.clientType === ClientType.WEB ||
      from.clientType === ClientType.PC
    );
  } else {
    const artStr = get(message, "from.art", "");
    if (!artStr) {
      return true;
    }
    const art = attempt(JSON.parse, artStr);
    if (isError(art)) {
      return true;
    }
    const clientType = art.clientType || "";
    return (
      clientType === ClientType.IPAD ||
      clientType === ClientType.MAC ||
      clientType === ClientType.WEB ||
      clientType === ClientType.PC
    );
  }
}

export function getNoticeNotifyMessage(
  session: Session,
  message: any,
  currentEmployee: Employee
): any {
  return {
    name: session.info.name,
    avatar: session.info.avatar,
    content: message.title
  };
}

export function getSingleNotifyMessage(
  session: Session,
  message: any,
  currentEmployee: Employee
): any {
  return {
    name: session.info.name,
    avatar: session.info.avatar,
    content: getLastMessageDesc(message, session.sessionType, currentEmployee, true, session)
  };
}

export function getGroupNotifyMessage(
  session: Session,
  message: any,
  currentEmployee: Employee
): any {
  return {
    name: session.info.name,
    avatar: session.info.avatar,
    content: getLastMessageDesc(message, session.sessionType, currentEmployee, true, session)
  };
}

/**
 * 无效session
 * @param session
 */
export function isInValidSession(session: Session): boolean {
  const { timestamp, info } = session || {};
  return !(timestamp && info && info.name);
}

export const isInValidSessionInfo = isInValidSession;

/**
 * 是置定的会话
 * @param session
 */
export function isTopSession(session: Session): boolean {
  return ((session.settings || {}).top || 0) > 0;
}

/**
 * 阅后即焚会话焚毁时间
 * @param session
 */
export function messageBurnOfSession(session: Session): number {
  return (session.settings || {}).messageBurn || 0;
}

/**
 * 免打扰会话
 */
export function isShieldSession(session: Session): boolean {
  return ((session.settings || {}).shield || 0) > 0;
}

/**
 * 显示成员昵称
 * @param session
 * @returns
 */
export function isDisplayAliasSession(session: Session): boolean {
  return ((session.settings || {}).displayAlias || 0) === 1;
}

/**
 * 是否开启权限检查，全员可邀请入群
 * @param session
 */
export function isPermissionCheckSession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return info.permissionCheck === 0;
  }
  return false;
}

/**
 * 加群验证
 * @param session
 */
export function isNeedVerifySession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return info.needVerify === 1;
  }
  return false;
}

/**
 * 是可搜索的群会话
 * @param session
 */
export function isCanSearchGroupSession(session: Session): boolean {
  return session.isGroup && (session.info as Group).canSearch === 1;
}

/**
 * 是按单位选择成员的会话 群组 反着来 0可见  1不可见
 * @param session
 */
export function isGroupVisibleUnit(session: Session): boolean {
  return session.isGroup && (session.info as Group).visibleUnit === 1;
}

/**
 * 显示成员单位名称的会话
 * @param session
 */
export function isGroupChatVisibleUnit(session: Session): boolean {
  // console.log('session.info', session.info);
  return session.isGroup && (session.info as Group).chatVisibleUnit === 1;
}

/**
 * 显示成员单位-职务名称的会话
 * @param session
 */
export function isGroupvisiblePost(session: Session): boolean {
  return session.isGroup && (session.info as Group).visiblePost === 1;
}

/**
 * 允许成员设置昵称
 * @param session
 * @returns
 */
export function isGroupSetAlias(session: Session): boolean {
  return session.isGroup && (session.info as Group).setAlias === 1;
}

export function isShowAlias(session: Session): boolean {
  return isGroupSetAlias(session) && isDisplayAliasSession(session);
}

export function findRemark(session: Session, user: Employee): string {
  const rosters = (session.info as any)?.rosters || {};
  const idString = convertEmployeeToString(user);
  let remark = "";
  if (Object.keys(rosters).length) {
    const target = rosters[idString];
    if (target) {
      const employeeExt = target.info?.employeeExt;
      if (employeeExt?.remark) {
        remark = employeeExt.remark;
      }
    }
  } else {
    remark = user?.employeeExt?.remark;
  }
  return remark;
}

/**
 * 是加群验证的群会话
 * @param session
 * GroupApprovalRule.IDENTITY 只能群主或管理员能主动邀请进群，主动进群和普通成员邀请会被拒绝
 */
export function isIdentityApproveRuleGroupSession(session: Session): boolean {
  return session.isGroup && (session.info as Group).approvalRule === GroupApprovalRule.PRE_APPROVAL;
}

/**
 * 是禁言全体群成员（不包括群主）的群会话
 * @param session
 * forbidAll 1全员禁言 0或空 正常发言状态
 */
export function isBannedPostGroupSession(session: Session): boolean {
  return session.isGroup && (session.info as Group).forbidAll === 1;
}

/**
 * 是可以查看全体成员群成名
 * @param session
 * forbidAll 2 可以查看，其它不可以
 */
export function isCardViewGroupSession(session: Session): boolean {
  return ((session.isGroup && (session.info as Group).forbidViewCard) || 2) === 2;
}
/**
 * 消息精确到秒显示
 * @param session
 */
export function isGroupShowMsgTime(session: Session): boolean {
  return session.isGroup && (session.info as Group).showMsgTime === 1;
}

/**
 * 显示消息回执
 * @param session
 */
export function isGroupShowMsgReply(session: Session): boolean {
  return session.isGroup && (session.info as Group).msgDongRead === 1;
}


/**
 * 是否是智能聚合组
 * @param session
 */
export function isGroupAIMerge(session: Session): boolean {
  return sdkIsGroupAIMerge(session);
}

/**
 * 是否是智能回复组
 * @param session
 * @returns
 */
export function isGroupAIReply(session: Session): boolean {
  if (!session.isGroup) {
    return false;
  }
  const ext = session.isGroup && (session.info as Group).ext;
  try {
    if (ext) {
      const extItem: any = typeof ext === "string" ? JSON.parse(ext) : ext;
      return extItem?.showAIReply === 1;
    }
  } catch (e) {
    return false;
  }
  return true;
}

/**
 * 是否包含快捷回复话术
 */
export function isQuickReplyText(msg: ChatMessage, quicks: string[]): boolean {
  if (msg.type !== ChatMessageType.TEXT) {
    return false;
  }
  const items = quicks.filter((i: any) => msg.content?.includes(i));
  return items.length > 0;
}

// 判断是不是专班群
// export function

/**
 * 是否同一会话
 * @param sessionI
 * @param sessionII
 */
export function isEqualSession(sessionI: Session, sessionII: Session): boolean {
  return sessionI.sessionId === sessionII.sessionId;
}

export function isSpecialProjectGroup(group: Group) {
  return group.business === "project" || group.business === "project_default";
}

export function isSpecialProjectMasterGroup(group: Group) {
  return group.business === "project_default";
}

/**
 * 判断是不是外部群 app一样  teamId不一样
 * @param group
 */
export function isExternalGroup(group: Group): boolean {
  return (
    sysMsgConfig["show-external-tag"] && group.kind === GroupKind.EXTERNAL && group.subKind === 6
  );
}

/**
 * 判断是不是跨平台群会话 app不一样--功能用
 * @param group
 */
export function isCrossPlatformGroup(group: Group): boolean {
  return group.kind === GroupKind.EXTERNAL && group.subKind === 3;
}

/**
 * 判断是不是跨平台群会话 app不一样---tag用
 * @param group
 */
export function isCrossPlatformGroup_toTag(group: Group): boolean {
  return (
    sysMsgConfig["show-external-tag"] && group.kind === GroupKind.EXTERNAL && group.subKind === 3
  );
}

/**
 * 判断是不是外部群会话
 * @param session
 */
export function isExternalGroupSession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return isExternalGroup(info);
    // return info.kind === GroupKind.EXTERNAL && info.subKind === 6;
  }
  return false;
}

/**
 * 判断是不是专班群会话
 * @param session
 */
export function isSpecialProjectSession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return isSpecialProjectGroup(info) || isSpecialProjectMasterGroup(info);
  }
  return false;
}

/**
 * 判断是不是专班大群会话
 * @param session
 */
export function isSpecialProjectMasterSession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return isSpecialProjectMasterGroup(info);
  }
  return false;
}

/**
 * 判断是不是任务融合群会话
 */
export function isWorkSession(session: Session): boolean {
  if (session?.info?.business === "work") {
    return true;
  }
  return false;
}

/**
 * 判断是不是跨平台群会话
 * @param session
 */
export function isCrossPlatformGroupSession(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return isCrossPlatformGroup(info);
    // return info.kind === GroupKind.EXTERNAL && info.subKind === 3;
  }
  return false;
}

/**
 * 判断是不是跨平台群会话---标签用
 * @param session
 */
export function isCrossPlatformGroupSession_toTag(session: Session): boolean {
  if (session.isGroup) {
    const info = session.info as Group;
    return isCrossPlatformGroup_toTag(info);
    // return info.kind === GroupKind.EXTERNAL && info.subKind === 3;
  }
  return false;
}

/**
 * 获取会话配置项，开关值
 * @param session
 * @param type
 */
export function getSessionSettingValue(session: Session, type: SessionSettingsType): boolean {
  switch (type) {
    case SessionSettingsType.TOP:
      return isTopSession(session);
    case SessionSettingsType.SHIELD:
      return isShieldSession(session);
    case SessionSettingsType.DISPLAY_ALIAS:
      return isDisplayAliasSession(session);
    case SessionSettingsType.SET_ALIAS:
      return isGroupSetAlias(session);
    case SessionSettingsType.PERMISSION_CHECK:
      return isPermissionCheckSession(session);
    case SessionSettingsType.VISIBLE_UNIT:
      return !isGroupVisibleUnit(session);
    case SessionSettingsType.CHAT_VISIBLE_UNIT:
      return isGroupChatVisibleUnit(session);
    case SessionSettingsType.VISIBLE_POST:
      return isGroupvisiblePost(session);
    case SessionSettingsType.NEED_VERIFY:
      return isNeedVerifySession(session);
    case SessionSettingsType.CAN_SEARCH:
      return isCanSearchGroupSession(session);
    case SessionSettingsType.APPROVAL_RULE:
      return isIdentityApproveRuleGroupSession(session);
    case SessionSettingsType.BANNED_POST:
      return isBannedPostGroupSession(session);
    case SessionSettingsType.CARD_VIEW:
      return isCardViewGroupSession(session);
    case SessionSettingsType.SHOW_MSG_TIME:
      return isGroupShowMsgTime(session);
    case SessionSettingsType.MSG_DONG_READ:
      return isGroupShowMsgReply(session);
    case SessionSettingsType.AI_MERGE:
      return isGroupAIMerge(session);
    case SessionSettingsType.AI_REPLY:
      return isGroupAIReply(session);
    default:
      return false;
  }
}

/**
 * 不可以打开用户名片
 * @param session 当前的会话
 * @param currentEmployee 当前操作用户
 * @param targetEmployee 要点开的用户
 */
export function canNotOpenUserCard(
  session: Session,
  currentEmployee: Employee | EmployeeAttribute,
  targetEmployee: Employee | EmployeeAttribute
) {
  if (isGroupOwner({ session, currentEmployee })) {
    // 如果是群管理员，没有此限制，可以查看。
    return false;
  }
  return !isEqualEmployee(currentEmployee, targetEmployee) && !isCardViewGroupSession(session);
}

/**
 * 拒绝入群 群助手卡片提示内容
 * xxx 拒绝 你 邀请 xxx 加入 xxx
 */
// eslint-disable-next-line max-params
export function rejectAddGroupApplyContent(
  groupOwner: Employee,
  inviter: Employee,
  invitee: Employee[],
  group: Group
): string {
  const tags = [];
  tags.push(
    `<span data-label="groupOwner" data-value="${convertUidToString(
      employeeToUid(groupOwner)
    )}" class="apply-details-content-link groupOwner">${groupOwner.name}</span>`
  );
  tags.push(`<span>${i18n.t("chat:apply.refuse")}</span>`);
  tags.push(
    `<span data-label="inviter" data-value="${convertUidToString(
      employeeToUid(inviter)
    )}" class="apply-details-content-link inviter">${i18n.t("chat:apply.you")}</span>`
  );
  tags.push(`<span>${i18n.t("chat:apply.invite")}</span>`);
  tags.push(
    `<span data-label="invitee" data-value="${convertUidToString(
      employeeToUid(invitee[0])
    )}" class="apply-details-content-link invitee">${invitee[0].name}</span>`
  );
  tags.push(`<span >${i18n.t("chat:apply.add")}</span>`);
  tags.push(
    `<span data-label="group" data-value="${group.gid}" class="apply-details-content-link group">${group.name}</span>`
  );
  return tags.join("");
}

export function convertEmployeeToString(employee: Employee): string {
  return `${employee.userId}:${employee.app}:${employee.teamId}`;
}

// @单位/部门匹配人员
export function extraConvertEmployeeToString(employee: any): string {
  return `${employee.userId}:${employee.app}:${employee.teamId}:${employee.role}`;
}

export function filterDeptFullName(deptFullName: string | undefined): string {
  if (!deptFullName) {
    return "";
  }
  const fileds = deptFullName.split("-");
  const length = fileds.length;
  return length > 2 ? fileds[length - 2] : fileds[length - 1];
}

/**
 * userId转换成
 * @export
 * @param {User} user
 * @return {*}  {string}
 */
export function convertUserToString(user: User): string {
  return `${user.userId}:${user.appId}:${user.teamId}`;
}

export function parseEmployeeFromString(id: string): Employee {
  const seeds = id.split(":");
  const employee = {
    userId: seeds[0],
    app: seeds[1],
    teamId: seeds[2]
  };
  return employee as Employee;
}

export function addContactsSuccess(message: any): boolean {
  return (
    message &&
    ((message.type === ChatMessageType.SYS && message.sys_msg_type === "SetRosterSuccessNotice") ||
      (message.type === ChatMessageType.TEXT && message?.extend?.addRoster))
  );
}

export function isMergeForwardMessage(message: any, selectedSession: Session) {
  return (
    message?.template?.nativeId === "merge_forward" &&
    message?.sessionId !== selectedSession.sessionId
  );
}

export function isJoyWorkMessage(message: any): boolean {
  return message && message.flag === 10000;
}

export function isJoyMeetingMessage(message: any): boolean {
  return message && message.flag === 100 && message.ext && message.ext.avsdk === AVSDK.ZOOM;
}

export function isCloudLinkMeetingMessage(message: any): boolean {
  return message?.ext && message.ext.avsdk === AVSDK.HUAWEI;
}

export function isJAVSDKMeetingMessage(message: any): boolean {
  const avsdk = message?.ext?.avsdk;
  if (!avsdk) {
    return false;
  }
  return [AVSDK.JBRTC, AVSDK.XYLINK, AVSDK.HUAWEI, AVSDK.ZOOM].includes(avsdk);
}

export function isSuperviseMessage(message: any): boolean {
  return message?.from?.pin === "eopen-push_0Gl8b1I3si21n0VVNkrF";
}

export function isTaskMessage(message: any): boolean {
  return message?.from?.pin === "eopen-push_PZzzvgDrpZVAefKImEfo";
}

export function isCalendarMessage(message: any): boolean {
  return message?.from?.pin === "~me69";
}

export function isSysNoticeMessage(message: any): boolean {
  return message?.from?.pin === "eopen-push_W7pvLoOlvIg9NlOUzcvg";
}

export function isAnnounceMessage(message: any): boolean {
  return message?.from?.pin === "eopen-push_gc1EijDXzxUehGW1ydK5";
}

export function isCloudFileFunc(message: any): boolean {
  let isCloudFile = false;
  if (message.type === ChatMessageType.TEMPLATE2) {
    const sharelink =
      message.data && message.data[0] ? message.data[0].sharelink : { category: "", url: "" };
    const { template } = message;
    if (template.nativeId === "share_link") {
      if (sharelink?.category === "jd_doc") {
        isCloudFile = true;
      } else {
        isCloudFile = sharelink.url.includes("joyspace");
      }
    }
  } else if (
    message.type === ChatMessageType.JOYSPACEFILE
    // 文件夹暂时不支持转任务和日程||message.type === ChatMessageType.JOYSPACEFOLDER
  ) {
    return true;
  }
  return isCloudFile;
}

/**
 *
 * 经协商，多端同步消息使用flag为10000
 * 具体应用使用appname区分
 */
export function isMultiSyncMessage(message: any): boolean {
  return message && message.flag === 10000;
}

export function isImageTextCardMessage(message: any): boolean {
  return message?.subCardType && message?.subCardType === "imageCard";
}

/**
 * message 排序算法
 * @param a
 * @param b
 */
export function messageCompare(a: ChatMessage, b: ChatMessage) {
  // system message
  if (!a.mid || !b.mid) {
    return a.timestamp - b.timestamp;
  }
  if (a.mid <= 0 && b.mid <= 0) {
    if (a.beforeMid === b.beforeMid) {
      return a.timestamp - b.timestamp;
    } else {
      return a.beforeMid - b.beforeMid;
    }
  } else if (a.mid <= 0) {
    if ((a.state && a.state & 4) === 4) {
      return a.timestamp - b.timestamp;
    } else {
      return a.beforeMid - b.mid;
    }
  } else if (b.mid <= 0) {
    if (b.state && (b.state & 4) === 4) {
      return a.timestamp - b.timestamp;
    } else {
      return a.mid - b.beforeMid;
    }
  }
  return a.mid - b.mid;
}

export function processMessageStatus(
  session: Session,
  messages: ChatMessage[],
  currUser: Employee
): ChatMessage[] {
  if (!session.sessionId || session.isGroup || session.isNotice || messages.length < 2) {
    return messages;
  }
  const lastMsg = messages[messages.length - 1];
  const lastOtherMsg = findLast(
    messages,
    (m) => m.mid < lastMsg.mid && !isEqualEmployee(m.sender, currUser)
  );
  if (!lastMsg.sender) {
    return messages;
  }
  const pres = messages.slice(0, messages.length - 1);
  const unreads = pres
    .filter(
      (i) =>
        isEqualEmployee(i.sender, currUser) &&
        i.readUids?.length === 0 &&
        lastOtherMsg &&
        i.mid < lastOtherMsg?.mid
    )
    .map((i) => i.id);
  if (unreads.length === 0) {
    return messages;
  }
  const toUser = parseMessageToUserBySingle(session.sessionId, currUser);
  const res = messages.map((i) => {
    if (unreads.includes(i.id)) {
      i.isRead = 1;
      i.readUids = [toUser];
    }
    return i;
  });
  return res;
}

export function parseMessageToUserBySingle(sessionId: string, currUser: Employee) {
  const [uid1, uid2] = parseUidFromSingleSessionId(sessionId);
  if (isEqualUid(uid1, employeeToUid(currUser))) {
    return uid2;
  } else {
    return uid1;
  }
}

export function getLatestMessages(messages: any[]) {
  // console.log('getLatestMessages', messages);
  let tempMessagesMap = new Map();
  messages.forEach((msg: any) => {
    if (tempMessagesMap.has(msg.id)) {
      const message = tempMessagesMap.get(msg.id);
      if (message.isRead < msg.isRead) {
        tempMessagesMap.set(msg.id, msg);
      } else if (message.timestamp <= msg.timestamp) {
        // tempMessagesMap.set(msg.id, {
        //     ...msg,
        //     timestamp: message.timestamp,
        // });
        tempMessagesMap.set(msg.id, msg);
      }
    } else {
      tempMessagesMap.set(msg.id, msg);
    }
  });
  let tempMessages: any[] = [];
  tempMessagesMap.forEach((value: any) => {
    tempMessages.push(value);
  });
  return tempMessages;
}

export function uniqMergedMessage(messages: any[]) {
  const plus = messages.filter((msg) => {
    return msg.plusList && msg.plusList.length;
  });
  const ids = flatMapDeep(plus.map((p) => p.plusList.map((m: any) => m.uuid)));
  const msgs = uniqWith(messages, (v1, v2) => {
    if (v1.plusList && v2.plusList) {
      const ids1 = v1.plusList
        .map((t: any) => t.uuid)
        .sort()
        .join(",");
      const ids2 = v2.plusList
        .map((t: any) => t.uuid)
        .sort()
        .join(",");
      return ids1 === ids2;
    }
    return false;
  });
  return msgs.filter((msg) => {
    return ids.indexOf(msg.id) === -1 || msg.rawId;
  });
}

export function sendGroupSessionNotify(allSessionList: Session[]) {
  const payload = allSessionList.reduce((result: any, session: Session) => {
    if (session.isGroup) {
      result.push({
        sessionId: session.sessionId,
        gid: session.gid,
        unreadCount: session.unreadCount,
        lastMsg: session.lastMsg
      });
    }
    return result;
  }, []);
  if (payload.length === 0) {
    return;
  }
  const data = {
    source: "group-session-info",
    payload
  };

  window.postMessage(data, location.origin);
}

/**
 * 根据selectedPin筛选内容
 * @param allSessionMessages 会话内容
 * @param selectedPin 选中的tab类型
 */
export function filterNoticeMassagesByType(allSessionMessages: ChatMessage[], selectedPin: string) {
  let sessionMessages: ChatMessage[] = [];
  switch (selectedPin) {
    case CHAT_NOTICE.ALL_PIN:
      sessionMessages = allSessionMessages;
      break;
    case CHAT_NOTICE.OTHER_PIN:
      sessionMessages = allSessionMessages.filter(
        (message) => !OTHER_EXCLUDE_TABS_PIN.includes(message?.from?.pin)
      );
      break;
    default:
      sessionMessages = allSessionMessages.filter((message) => message?.from?.pin === selectedPin);
      break;
  }
  return sessionMessages.sort((a: { timestamp: any }, b: { timestamp: any }) => {
    return (a.timestamp || 0) - (b.timestamp || 0);
  });
}

/**
 * 计算ai助手会话最新的时间戳
 * @param aiNoticeSessionList ai助手列表
 * @returns 最大的时间戳
 */
export function computeAITimestamp(aiNoticeSessionList: Session[]) {
  if (!aiNoticeSessionList.length) {
    return Date.now();
  }
  const last = aiNoticeSessionList.reduce((a, b) => {
    const aTime = a?.lastMsg?.timestamp || a.timestamp;
    const bTime = b?.lastMsg?.timestamp || b.timestamp;
    if (aTime < bTime) {
      return b;
    } else {
      return a;
    }
  });
  return last?.lastMsg?.timestamp || last?.timestamp || Date.now();
}

export function computeAIUnReadInfo(aiNoticeSessionList: Session[]) {
  if (!aiNoticeSessionList.length) {
    return {};
  }
  const unreadSessions = aiNoticeSessionList.filter((a) => a.unreadCount > 0);
  const lastSessions = unreadSessions.sort((a, b) => {
    const aTime = a?.lastMsg?.timestamp || a.timestamp;
    const bTime = b?.lastMsg?.timestamp || b.timestamp;
    return aTime - bTime;
  });
  const unreadCount = unreadSessions.reduce((a, b) => {
    return a + (b.unreadCount || 0);
  }, 0);
  const first = lastSessions[0];
  const last = lastSessions[lastSessions.length - 1];
  const res = {
    lastReadMsg: { sessionId: first?.sessionId, mid: first?.lastReadMid },
    lastMsg: last?.lastMsg || {},
    unreadCount
  };
  return res;
}

export function forwardLimitSessionNum(
  list: any,
  limit_session: number,
  limit_session_single: number
) {
  const groupsLength = (list.filter((item: any) => item.isGroup) || []).length;
  const singlesLength = (list.filter((item: any) => !item.isGroup) || []).length;
  if (
    groupsLength > limit_session ||
    singlesLength > limit_session_single ||
    groupsLength + singlesLength > limit_session + limit_session_single
  ) {
    return false;
  }
  return true;
}

// 转发留言选择会话数据处理
export async function selectedSessionsToForward(list: any) {
  const optionResult: { gids: string[]; uids: UID[] } = { gids: [], uids: [] };
  const options = list.reduce((result: { gids: string[]; uids: UID[] }, item: any) => {
    if (item.isGroup) {
      result.gids.push(item.id);
    } else {
      result.uids.push({
        pin: item?.pin || item?.origin?.uid?.pin,
        app: item?.app || item?.origin?.uid?.app,
        teamId: item?.teamId || item?.origin?.uid?.teamId
      });
    }
    return result;
  }, optionResult);
  return options;
}

/**
 * 单条消息转发留言  多条消息逐条转发、合并转发留言
 * @param options 消息接收方
 * @param content 留言内容
 */

export async function forwardLeaveWord(
  currentEmployee: Employee,
  options: { gids: string[]; uids: UID[] },
  content: string
) {
  const imService = ImService.getInstance();
  const messageBody = {
    type: ChatMessageType.TEXT,
    content
  } as any;

  const groupSessions = options.gids.map((item) => {
    return { sessionId: item };
  });
  const singleSessions = options.uids.map((item) => {
    return { sessionId: imService.generateSingleSessionId(currentEmployee, item) };
  });
  const sessions: any[] = [...groupSessions, ...singleSessions];
  // console.log('要留言的会话', groupSessions, singleSessions, sessions);
  let imSendPromise = [];
  for (let session of sessions) {
    const messageId = generateMessageId();
    imSendPromise.push(
      imService.sendChatMessage(session.sessionId, messageId, {
        ...messageBody,
        id: messageId
      })
    );
  }
  Promise.all(imSendPromise);
}

/**
 * 发送图片、文件支持Enter发送条件校验
 * @param isMulti 是否发送多个
 * @param selectedList 选中列表
 */
export function sendMessageByKeyboard(e: any, isMulti: boolean, selectedList: any[]) {
  e.preventDefault();
  e.stopPropagation();
  // console.log('mention keydown', e.key);
  if (e.key === "Enter") {
    if (isMulti) {
      if (!selectedList?.length) {
        return false;
      }
      return true;
    }
    return true;
  }
}

// 判断是否有选中的文字
export function getSelected() {
  if (window.getSelection) {
    return window.getSelection()?.toString();
  } else {
    let documents: any = document;
    const selection = documents.selection?.createRange();
    if (selection.text) {
      return selection.text.toString();
    }
    return "";
  }
}
// 判断图片地址是否有效
export function checkImgExists(imgurl: any) {
  return new Promise(function (resolve, reject) {
    let ImgObj = new Image();
    ImgObj.src = imgurl;
    ImgObj.onload = function (res) {
      resolve(res);
    };
    ImgObj.onerror = function (err) {
      reject(err);
    };
  });
}

/**
 * 语音转文字
 */
export async function voiceToTextFn({
  session,
  message,
  map,
  setMap
}: {
  session: Session;
  message: any;
  map: VoiceMessageMap[];
  setMap: Function;
}) {
  if (!message.url) {
    console.log("语音消息url null");
    return;
  }
  // const voiceUrl = addXtoken(message.url);
  // console.log('语音转文字消息url', voiceUrl);
  const data = await voiceToText(message.url);
  // console.log('语音转文字消息结果', data);
  const result = data[0];
  Bus.emit(`voice:convertText:${session.sessionId}:${message.mid}`, result || "");
  const temp = map;
  const index = temp.findIndex((item: VoiceMessageMap) => item.mid === message.mid);
  if (index === -1) {
    temp.push({ mid: message.mid, text: result });
  } else {
    temp[index].text = result;
  }
  console.log("temp", temp);
  setMap(temp);
}
export async function updateVoiceMessageReadStatus(
  message: any,
  updateSessionMessageMid: Function,
  updateSessionMessagesTimestamp: Function
) {
  if (message.isPlayOrTurn) {
    return;
  }
  const imService = ImService.getInstance();
  const result = await imService.updateVoiceMessage(message.sessionId, message.mid);
  if (result) {
    await updateSessionMessageMid({
      sessionId: message.sessionId,
      sendResult: {
        body: { ...message, isPlayOrTurn: true }
      }
    });
    await updateSessionMessagesTimestamp({
      timestamp: new Date().getTime()
    });
  }
}

export function generateSessionMid(mid: number): number {
  const _mid = mid || 1;
  return Number(_mid * 1000 + 0.01 * 1000) / 1000;
}

export const widthMap = [
  { width: 80, value: "1,2" },
  { width: 90, value: "3,4" },
  { width: 100, value: "5,6" },
  { width: 110, value: "7,8" },
  { width: 120, value: "9,10" },
  { width: 132, value: "11,20" },
  { width: 144, value: "21,30" },
  { width: 156, value: "31,40" },
  { width: 168, value: "41,50" },
  { width: 180, value: "51,60" }
];

export function getVoiceMsgWidth(message: any): any {
  const target = widthMap.find((item) => {
    const [min, max] = item.value.split(",");
    const duration = Number(message.duration);
    return Number(min) <= duration && Number(max) >= duration;
  });
  return target ? target.width : 160;
}

export function getUnitTitleInfo(unitName: string | undefined, titleName: string | undefined) {
  if (unitName) {
    return `${unitName}-${titleName || "暂无岗位"}`;
  } else {
    return titleName || "暂未填写";
  }
}

export function isQuillMsg(quillJson?: any) {
  if (!quillJson) {
    return false;
  }
  for (const item of quillJson) {
    if (item?.attributes || item?.insert?.image) {
      return true;
    }
  }
  return false;
}

export function showIntentRootTail(msg: any) {
  // 非文件
  return (
    ![ChatMessageType.FILE, ChatMessageType.EGOV_FILE].includes(msg.type) && showIntentTail(msg)
  );
}

export function showIntentTail(msg: any) {
  return AI_CHAT_PREDICT_TYPE.includes(msg?.intentData?.predictType);
}

export enum MultiCardTemplateType {
  MultiImageText = "mulImageText",
  ImageText = "imageText",
  Text = "text"
}

export const getOrgNoticeMultiMessageData = (message: any) => {
  if (message?.type !== ChatMessageType.TEMPLATE2) {
    return {};
  }
  const dataInfo = get(message, "data.0.orgNumberCard", {}) || get(message, "data.0", {});
  return dataInfo;
};

export const isOrgNoticeMultiMessage = (message: any) => {
  const dataInfo = getOrgNoticeMultiMessageData(message);
  return dataInfo?.type === MultiCardTemplateType.MultiImageText;
};

export const isOrgNoticeSingleImageTextMessage = (message: any) => {
  const dataInfo = getOrgNoticeMultiMessageData(message);
  return dataInfo?.type === MultiCardTemplateType.ImageText;
};

export const isOrgNoticeImageTextCardMessage = (message: any) => {
  const dataInfo = getOrgNoticeMultiMessageData(message);
  return dataInfo?.type && dataInfo?.type !== MultiCardTemplateType.Text;
};

export const isOrgNoticeTextCardMessage = (message: any) => {
  const dataInfo = getOrgNoticeMultiMessageData(message);
  return dataInfo?.type === MultiCardTemplateType.Text;
};

// export function dealDelta(delta: any) {
//   const arr = JSON.parse(delta);
//   arr.forEach((item: any) => {
//     if (!item.insert) {
//       return;
//     }
//     switch (typeof item.insert) {
//       case ""
//     }
//   })
// }

export const isImagePredictType = (type: any) => {
  return [
    AI_CHAT_PREDICT.IMG_EXPLAIN,
    AI_CHAT_PREDICT.IMG_EXTRA_TEXT,
    AI_CHAT_PREDICT.IMG_QUIZ
  ].includes(type);
};

export const ALLOW_IMAGE_TYPE = ["image/png", "image/jpeg", "image/gif", "image/bmp", "image/webp"];
// 获取下载文件的bizType
export function getFileDownloadBzType(data: any) {
  const { sessionType, sessionId = "", notificationId } = data;
  if (notificationId) {
    return FILE_DOWNLOAD_BIZTYPE.groupnotice;
  }
  let type = "";
  if (sessionType) {
    type = [SessionType.SINGLE, SessionType.SECRET_SINGLE].includes(sessionType)
      ? FILE_DOWNLOAD_BIZTYPE.unimessage
      : SessionType.GROUP
      ? FILE_DOWNLOAD_BIZTYPE.group
      : "";
  }
  if (type) {
    return type;
  }
  if (sessionId) {
    const sids = sessionId?.split(":");
    type = sids?.length === 1 ? FILE_DOWNLOAD_BIZTYPE.group : FILE_DOWNLOAD_BIZTYPE.unimessage;
  }
  return type;
}

// 获取其他类型
export function getFileDownloadBzOtherType(type: BusinessForm) {
  switch (type) {
    case BusinessForm.CALENDAR:
      return FILE_DOWNLOAD_BIZTYPE.schedule;
    case BusinessForm.TASK:
      return FILE_DOWNLOAD_BIZTYPE.task;
    default:
      return "";
  }
}

// 获取下载文件的bizId
export function getFileDownloadBzId(data: any, currentEmployee?: Employee) {
  const { sessionId, notificationId } = data;
  return notificationId || sessionId;
}

// 获取下载业务字段
export function getFileDownloadBzOptions(data: any, currentEmployee?: Employee) {
  const bizType = getFileDownloadBzType(data);
  const bizId = getFileDownloadBzId(data);
  return {
    bizType,
    bizId,
    teamId: currentEmployee ? currentEmployee?.teamId : ""
  };
}

// 文件下载业务类型
export const FILE_DOWNLOAD_BIZTYPE = {
  group: "group",
  unimessage: "unimessage",
  schedule: "calendar",
  task: "task",
  joyspace: "joyspace",
  im: "IM",
  groupnotice: "groupnotice"
};

export enum BusinessForm {
  CALENDAR = "CALENDAR", // 日程
  TASK = "TASK" // 任务
}

export interface IBizOptions {
  bizId?: string;
  bizType?: string;
  teamId?: string;
  [keys: string]: any;
}
